/* eslint-disable max-len */

// Do not add to this file. We don't want to support translations in the admin anymore

export const AppLabelsModule = angular.module('app.labels', [])
    .constant('appLabels', {
        ADDRESS: {
            ADD: 'Add an Address',
            ADDBILLING: 'Add a Billing Address',
            ADDRESS1: 'Address Line 1',
            ADDRESS2: 'Address Line 2 (optional)',
            ADDSHIPPING: 'Add a Shipping Address',
            BILLINGADDRESS: 'Billing Address',
            CITY: 'City',
            COMPANY: 'Company (optional)',
            EDIT: 'Update Address',
            EDITBILLING: 'Update Billing Address',
            EDITSHIPPING: 'Update Shipping Address',
            FIRSTNAME: 'First Name',
            LASTNAME: 'Last Name',
            PHONENUMBER: 'Phone Number',
            PHONE_NUMBER_OPTIONAL: 'Phone Number (optional)',
            POSTALCODE: 'ZIP Code',
            STATE: 'State'
        },
        ANALYTICS: {
            ABANDONED_CARTS: 'Abandoned Carts',
            ABANDONED_CARTS_ABANDONED: 'Abandoned',
            ABANDONED_CARTS_AVERAGE_ITEMS: 'Average Items per Cart',
            ABANDONED_CARTS_AVERAGE_VALUE: 'Average Cart Value',
            ABANDONED_CARTS_CHART_TITLE: 'Conversion',
            ABANDONED_CARTS_CONVERTED: 'Converted',
            ABANDONED_CARTS_DETAILS_BTN: 'View Details',
            ABANDONED_CARTS_ERROR_DESCRIPTION: 'Error getting abandoned cart data',
            ASOF: 'as of',
            AVERAGESESSION: 'Average Session',
            CARTDETAILS: 'Cart Details',
            CARTID: 'Cart Id',
            CARTS: 'Carts',
            CUSTOMERLABEL: 'Customer',
            DATE_FILTER: 'Data from the',
            DESKTOP: 'Desktop',
            ERRORDESCRIPTION: 'Error getting analytics data',
            ERROR_TITLE: 'Error',
            EXPORTORDERS: 'Export orders',
            EXPORT_ABANDONED_CARTS: 'Export carts',
            GROSSREVENUE: 'Gross Revenue',
            ID: 'ID',
            ITEM: '{{COUNT}} Item',
            ITEMS: '{{COUNT}} Items',
            LAST_24_HOURS: 'last 24 hours',
            LAST_30_DAYS: 'last 30 days',
            LAST_7_DAYS: 'last 7 days',
            LAST_90_DAYS: 'last 90 days',
            MOBILE: 'Mobile',
            NO_ABANDONED_CART_DATA: 'No abandoned cart data to show.',
            NOABANDONEDCARTSDETAIL: 'When a customer adds an item to their cart but has not completed the purchase, you can see it here.',
            NOABANDONEDCARTSTITLE: 'Recover those carts',
            NODATAAVAILABLE: 'No data available',
            NOSALESDATA: 'No sales data to show.',
            NOTRAFFICDATA: 'No traffic data to show.',
            PAGESPERSESSION: 'Pages perSession',
            PERFORMANCE: 'Performance',
            TITLE: 'Analytics',
            TOPDEVICE: 'Top Device',
            TOTALORDERS: 'Total Orders',
            TOTALVISITS: 'Total Visits',
            TRAFFIC: 'Traffic',
            UNIQUEVISITS: 'Unique Visits'
        },
        APPSTORE: {
            MYAPPS: 'My Apps',
            APPLICATION: 'App',
            APPSTORETITLE: 'Integrations',
            APPSTORESUBTITLE: 'Access & install powerful new features to grow your Volusion store.',
            APPACCESS: 'Access & manage all your Volusion apps',
            CONFIRMINSTALLBUTTON: 'Confirm Install',
            CONFIRM_UNINSTALL_BUTTON: 'Confirm Uninstall',
            CONFIRMINSTALLFREEAPPBLURB: 'This is a free application. You will not be charged.',
            CONFIRM_UNINSTALL_APP_BLURB: 'By removing {{APP}}, you will no longer be able to view it in your Volusion admin or access its features.',
            CONFIRMINSTALLFREEAPPWITHPLUSBLURB: 'This is a free application with your Volusion subscription. You will not be charged.',
            CONFIRMINSTALLFREEEXTNBLURB: 'This is a free extension. You will not be charged.',
            CONFIRMINSTALLFREEEXTNWITHPLUSBLURB: 'This is a free extension with your Volusion plus subscription. You will not be charged.',
            APPINSTALLERROR: 'This app is available to our upgraded plans. Check them out here.',
            DESCRIPTION: 'Description',
            DEVELOPER: 'Developer',
            EMAILADDRESS: 'Email',
            EXTENDSAPPS: 'Extend these Apps',
            EXTENSION: 'Extension',
            EXTENSIONINSTALLED: '{{EXTENSION}} was installed successfully.',
            EXTENSIONS: 'Extensions',
            FEATUREDAPPS: 'Featured Apps',
            FEATUREDAPPSSUBTITLE: 'Grow your store with apps',
            FREE: 'Free',
            FREEWITHPLUSPLANLONG: 'Free With Volusion Plus',
            FREEWITHPLUSSHORT: 'Free W/Plus',
            GETSTARTEDTITLE: 'Get Started with our Featured Apps',
            GETSTARTEDSUBTITLE: 'You don\'t have any apps installed yet, check out our recommended apps below',
            INSTALLAPP: 'Install',
            INSTALLED: 'Installed',
            INSTALLEXTENSION: 'Install',
            INSTALLING: 'Installing',
            UNINSTALLING: 'Uninstalling',
            PERMISSIONS: 'APP PERMISSIONS',
            PERMISSIONS_BLURB: 'By installing this app, you allow it to:',
            SUPPORTINFO: 'Support Information',
            TITLE: 'Title',
            UNINSTALL: 'Uninstall',
            VIEWAPPSTORE: 'View App Store',
            VISITMARKETPLACEFORMORE: 'Visit the Marketplace for more',
            WEBSITE: 'Website'
        },
        BADGES: {
            ACTIVE: 'Active',
            PENDING: 'Pending',
            PRIMARY: 'Primary'
        },
        BUTTON: {
            ACCEPT: 'Accept',
            CANCEL: 'Cancel',
            CLOSE: 'Close',
            COPY: 'Copy',
            DELETE: 'Remove',
            EDIT: 'Edit',
            ERROR: 'Oops! There was an error. Tryagain.',
            NEXT: 'Next',
            OK: 'OK',
            PLACEORDER: 'Place Order',
            PREVIOUS: 'Previous',
            SAVE: 'Save',
            SAVECREATENEW: 'Save & create new',
            SAVERETURNLIST: 'Save & return to list',
            SAVESTAY: 'Save & stay',
            SHIPORDER: 'Ship& Complete',
            STOREFRONTCACHE: 'Storefront Cache Refresh',
            STOREFRONTPREVIEW: 'Storefront Preview',
            SUCCESS: 'Success'
        },
        CANCELACCOUNT: {
            CANCELBUTTON: 'Keep my store',
            CANCELLINGLOADING: 'Deleting store',
            CANCELLINGTITLE: 'Peace out!',
            DESCRIPTION: 'Goodbyes are always tough, especially when there\'s so much left unsaid. Please take a moment to share your thoughts so we can improve.',
            FEEDBACKPLACEHOLDER: 'What can we do better?',
            IUNDERSTAND: 'I understand I will lose access to any data in my store.',
            OKBUTTON: 'Delete my store',
            THANKSFORTRYINGOUTMSG: 'Thank you for trying out Volusion. We will redirect you to our website once your store is deleted.',
            TITLE: 'Say itain\'t so!'
        },
        CANCEL_STORE: {
            TITLE: 'Cancel Store',
            HEADER: 'Cancel Store',
            INFO_1: 'To cancel your store, give us a ring at <a href="tel:1-888-997-0994">1-888-997-0994</a> between 9am and 6pm CST.',
            INFO_2: 'Phone and Chat are available during business hours of 9am-6pm.',
            ACTION_HEADER: 'You can also',
            ACTION_SCHEDULE: 'Schedule a Call',
            ACTION_CHAT: 'Chat With Us'
        },
        CATEGORY: {
            ADD: 'Add a Category',
            ADDPRODUCT: 'Select a Product',
            CATEGORIES: 'Categories',
            PARENT_CATEGORY: 'Parent Category',
            CATEGORY_TITLE: 'Category Title',
            CREATENEW: 'Create a new category',
            CREATE_BUTTON_LABEL: 'Create Category',
            DELETE: 'Remove this category?',
            EDIT: 'Update Category',
            ERROR_SAVE: 'Error saving category. Ensure page URL is not already in use.',
            HIDECATEGORY: 'Hide This Category',
            INACTIVE: 'Hidden',
            MENUSWARNING: 'Will be removed from {{COUNT}} menus',
            MENUWARNING: 'Will be removed from {{COUNT}} menu',
            PRODUCTSWARNING: 'Will be removed from {{COUNT}} products',
            PRODUCTWARNING: 'Will be removed from {{COUNT}} product',
            SHOWCATEGORY: 'Show This Category',
            SUBCATEGORYWARNING: '{{COUNT}} subcategories will be removed'
        },
        CHANGEPLAN: {
            CHANGEPLAN: 'Change Your Plan',
            ERROR_DESCRIPTION: 'There was an error changing your plan',
            ERROR_TITLE: 'Error changing plan'
        },
        CHAT: {
            DESCRIPTION: 'What better way to offer help than through a quick chat on your website? It’s way faster than email and more efficient than phone. Don’t make your customers wait.',
            HEADING: 'The fastest way to help your customers.',
            LINK: 'How do I set this up?',
            TITLE: 'Live Chat',
            SIGNUP: 'Sign up for free',
            SIGNIN: 'Sign in with',
            DONTHAVE: 'Don\'t have a LiveChat account?',
            DASHBOARD: 'Live Chat Dashboard',
            DISCONNECT: 'Disconnect my account'
        },
        CHECKOUT: {
            BEENHEREBEFORE: 'Been here before?',
            CHOOSEMOREOPTIONS: 'Choose more options',
            CLICKTOCREATEACCOUNT: 'Click here to create an account.',
            CREATEACCOUNT: 'Create an account and add a payment method.',
            IHAVEANACCOUNT: 'I have an account.',
            LASTSTEP: 'Last step, {{FIRST_NAME}}!',
            NOPEFIRSTTIME: 'Nope, this is my first time!',
            NOTYOU: 'Not {{FIRST_NAME}}?',
            READYTOGO: 'We\'re ready to go!',
            SUCCESSISASTEPAWAY: 'Success is a step away.',
            THANKYOU: 'Thank you, {{FIRST_NAME}}.',
            WELCOMEBACK: 'Hey, welcome back, {{FIRST_NAME}}!',
            YESIHAVEANACCOUNT: 'Yes, I have an account.'
        },
        CHECKOUTCONTACTINFO: {
            CONTACTINFO: 'Contact Information',
            PAYMENTMETHOD: 'Payment Method'
        },
        CHECKOUTHELP: {
            CHATNOW: 'Chat online now',
            NEEDHELP: 'Need help or have something to ask? You can contact us 24/7.',
            PHONENUMBER: '1-800-646-3517',
            QUESTIONS: 'Questions?'
        },
        CHECKOUTINFO: {
            ALWAYSAVAILABLE: 'With Volusion you’ll have 24/7 access to our Austin-based support staff. We are always available to help you out!',
            HERETOHELP: 'Here to help',
            YOURSUCCESSISOURS: 'Your success is ours.'
        },
        CHECKOUTLOGIN: {
            EMAIL: 'Email',
            PASSWORD: 'Password',
            TITLE: 'Log in to your account'
        },
        CHECKOUTSIGNUP: {
            CANCELCHANGES: 'Cancel changes',
            CARDMESSAGE: 'This card will be charged for all recurring charges and will be linked to your store for any future purchases.',
            CONTACTINFO: 'Contact Information',
            COUPON_APPLY: 'Apply',
            COUPON_CLEAR: 'Clear',
            COUPON_INPUT_LABEL: 'Promo Code',
            COUPON_NOT_VALID: 'Promo code not valid. Note that most are case sensitive and require proper mix of upper and lower case.',
            CREATEYOURACCOUNT: 'Create your account',
            ENTEREMAILPASSWORD: 'Enter your email address and a password you’ll use to log in to your store.',
            HAVE_A_COUPON: 'Have a promo code?',
            PAYMENTMETHOD: 'Payment Method'
        },
        CHECKOUTTHANKYOU: {
            CONTINUEBUTTON: 'Success awaits'
        },
        CONFIGUREAPPLEPAY: {
            DISABLE_CONFIRM_CANCEL: 'Cancel',
            DISABLE_CONFIRM_DESCRIPTION: 'Disabling will remove the ability for your customers to place orders via Apple Pay. You can re-enable Apple Pay at any time.',
            DISABLE_CONFIRM_OK: 'Disable',
            DISABLE_CONFIRM_TITLE: 'Are you sure?'
        },
        CONFIGUREPAYPAL: {
            ACP_STATUS: 'Advanced Card Processing',
            CANCEL_BUTTON: 'Cancel',
            CANCEL_CONFIRM_CANCEL: 'Cancel',
            CANCEL_CONFIRM_DESCRIPTION: 'Cancelling this verification will take you back to the beginning of PayPal setup.',
            CANCEL_CONFIRM_OK: 'Continue',
            CANCEL_CONFIRM_TITLE: 'Are you sure?',
            CONNECT_BUTTON: 'Connect account',
            CONNECT_DISABLED_STEP_DESCRIPTION: 'Your shoppers cannot pay with PayPal on your Volusion store right now. Enable PayPal to offer PayPal payments. Once enabled you must connect your store to a new or existing PayPal Account to collect funds.',
            CONNECT_STEP_DESCRIPTION: 'Your shoppers can pay with PayPal on your Volusion store right now, but to collect the funds you must connect your store to a new or existing PayPal Account.',
            CONNECT_STEP_TITLE: 'Connect to PayPal',
            CONNECT_RETRY: 'Unable to connect PayPal account, please try again and make sure to grant the proper permissions.',
            CONNECTED_DESCRIPTION: 'Your Volusion store and PayPal account are connected! You can now process your PayPal Orders and collect funds.',
            CONNECTED_NOTIFICATION: 'PayPal successully connected!',
            CONNECTED_TITLE: 'Account Connected',
            CONNECTED_PAYPAL_CONTACT: 'Please contact PayPal if you have any questions.',
            CONNECTED_LIMIT_REACHED: 'You have reached your Limit Amount. Advanced Card Processing has been disabled.',
            PREFILL_ERROR_TITLE: 'Unable to complete PayPal connection',
            PREFILL_ERROR_DESCRIPTION: 'Sorry, something went wrong. You cannot connect to PayPal at this time. Please try again later.',
            DISABLE_CONFIRM_CANCEL: 'Cancel',
            DISABLE_CONFIRM_DESCRIPTION: 'Disabling will remove the ability for your customers to place orders via PayPal. You can re-enable PayPal at any time.',
            DISABLE_CONFIRM_OK: 'Disable',
            DISABLE_CONFIRM_TITLE: 'Are you sure?',
            DISABLED: 'PayPal disabled',
            DISABLED_CONNECTED: 'Your shoppers cannot pay with PayPal on your Volusion store right now. Enable PayPal to offer PayPal payments.',
            DISCONNECT_BUTTON: 'Disconnect',
            DISCONNECT_CONFIRM_CANCEL: 'Cancel',
            DISCONNECT_CONFIRM_DESCRIPTION: 'Disconnecting will remove the ability to process transactions via PayPal. To remove PayPal from your checkout page, please disable with the toggle switch.',
            DISCONNECT_CONFIRM_OK: 'Disconnect',
            DISCONNECT_CONFIRM_TITLE: 'Are you sure?',
            DISCONNECTED_NOTIFICATION: 'PayPal successully disconnected!',
            DISCONNECTING: 'Disconnecting',
            ENABLED: 'PayPal enabled',
            LEARN_MORE: 'Learn more about PayPal',
            MERCHANT_PAYER_ID: 'PayPal Merchant Payer ID',
            PAY_IN_FOUR_ENABLED: 'Pay Later Messaging enabled',
            PAY_IN_FOUR_DISABLED: 'Pay Later Messaging disabled',
            PAY_IN_FOUR_DISABLE_DESCRIPTION: 'Disabling will remove the Pay Later Messaging from checkout',
            RETURN_ERROR_TITLE: 'Error Connecting PayPal',
            RETURN_ERROR_DESCRIPTION: 'Sorry, something went wrong connecting PayPal to your store. Please try again.',
            UPGRADE_BUTTON: 'Upgrade account',
            VERIFY_DISABLED_STEP_DESCRIPTION: 'Your shoppers cannot pay with PayPal on your Volusion store right now. Enable PayPal to offer PayPal payments. Once enabled you must confirm your PayPal account email address. <a href="https://www.paypal.com/signin?returnUri=%2Factivation%2FbusinessSetup" target="_blank">Review your PayPal account</a> to learn more.',
            VERIFY_STEP_DESCRIPTION: 'To complete your connection, please confirm your PayPal account email address. <a href="https://www.paypal.com/signin?returnUri=%2Factivation%2FbusinessSetup" target="_blank">Review your PayPal account</a> to learn more.',
            VERIFY_STEP_TITLE: 'Verify with PayPal',
            VERIFY_ACCOUNT_LIMITED: 'Your PayPal Account has been limited by PayPal. Please check your PayPal account inbox for an email to determine the next steps for this.'
        },
        VOLUSION_PAYMENTS: {
            ACTIVATED_STEP_TITLE: 'Volusion Payments Activated',
            COMPLETE_STEP_TITLE: 'Account Setup Complete',
            EMAIL_CONFIRMATION_MODAL_HEADING: 'Check your email!',
            EMAIL_CONFIRMATION_DONE_BUTTON: 'Okay, sounds great!',
            FINISH_PAYMENTS_SETUP_BUTTON: 'Finish Volusion payments setup',
            LOGO_ALT: 'Volusion Payments',
            SELLING_POINT_1: 'Instantly accept credit card payments',
            SELLING_POINT_2: 'No monthly cost or hidden fees',
            SELLING_POINT_3: 'Automated daily payouts',
            VERIFICATION_INSTRUCTION: 'Please click the link in the email to finish your Volusion Payments account setup so you can start getting paid!',
            VERIFICATION_SENT_TO: 'We\'ve sent a verification email to:',
            VERIFY_STEP_DESCRIPTION: 'Simply provide us with additional details, and before you know it, we\'ll be transferring money directly into your bank account.',
            VERIFY_STEP_TITLE: 'Ready to get paid?'
        },
        CUSTOMDOMAIN: {
            ADD: 'Add',
            ADD_PLACEHOLDER: 'example.com',
            CREATEINPROGRESS_DESCRIPTION: 'Your custom domain request is being processed.',
            CUSTOMDOMAIN: 'Custom Domain',
            CREATE_FAILEDERROR: 'Domain creation failed. Please make sure you own the domain <strong>{{CUSTOM_DOMAIN}}</strong>.',
            DELETE_FAILEDERROR: 'Domain removal failed.',
            DELETEINPROGRESS_DESCRIPTION: 'Your request to remove your custom domain is being processed.',
            DOMAIN_NOT_REGISTEREDERROR: 'The domain name <strong>{{CUSTOM_DOMAIN}}</strong> is not yet registered, you must first register the domain name with any ICANN-accredited registrar. For more information on using a custom domain with Volusion see <a class="link" href="{{ \'CUSTOMDOMAIN.NAMESERVER_HELPLINK_URL\' | translate }}" target="_blank">here</a>',
            DOMAIN_ALREADY_REGISTEREDERROR: 'The domain <strong>{{CUSTOM_DOMAIN}}</strong> is in use on another store. Each store must have a unique domain name.',
            DOMAIN_REGISTRATION_FAILEDERROR: 'Domain already exists.',
            ERROR_DESCRIPTION: 'Failed to add custom domain.',
            ERROR_OK: 'Ok',
            ERROR_TITLE: 'Error',
            ETC: 'This process could take up to 30 minutes to complete.',
            HTTPS_REDIRECT_FAILEDERROR: 'HTTPS setup failed.',
            INPROGRESS: 'In Progress',
            NAMESERVER_COLLAPSE: 'Collapse',
            NAMESERVER_DNS: 'DNS',
            NAMESERVER_EXPAND: 'Expand',
            NAMESERVER_HELP: 'Next, you need to update your Domain Name Servers (DNS) through the company you purchased your domain from.',
            NAMESERVER_HELPLINK_TEXT: 'Read our helpful support article on how to do this.',
            NAMESERVER_HELPLINK_URL: 'https://help.volusion.com/launch-your-business/store-info-store-name-domains',
            NAMESERVER_RECORD: 'Record',
            NAMESERVER_REQUIREDDATA: 'Required Data',
            NAMESERVER_TITLE: 'Nameserver Update Info',
            OWNADOMAIN: 'Already own a domain?',
            REFRESH: 'Refresh',
            REMOVE: 'Remove',
            REMOVECONFIRM_CANCEL: 'Keep Domain',
            REMOVECONFIRM_DESCRIPTION: 'Your new domain name will be',
            REMOVECONFIRM_OK: 'Remove Domain',
            REMOVECONFIRM_TITLE: 'Remove custom domain?',
            UPGRADETEXTV2: 'Upgrade to Volusion Plus to add a custom domain and add unlimited products!',
            VALIDATIONERROR: 'Valid domain name required (e.g. mydomain.com)'
        },
        CUSTOMER: {
            ADD: 'Add Customer',
            AVG: 'avg',
            CUSTOMERS: 'customers',
            EXPORTCUSTOMERS: 'Export Customers',
            IMPORT_CUSTOMERS_MENU: 'Import Customers',
            LASTORDER: 'Last Order',
            NEW30DAYS: 'New In Last 30 Days',
            NOCUSTOMERS: 'No customers were found.',
            ORDERS: 'Orders',
            PHONE: 'Phone Number',
            PRIMARYBILLING: 'Primary Billing',
            PRIMARYSHIPPING: 'Primary Shipping',
            SAMEADDRESS: 'same as shipping',
            SELECTEDPLURAL: '{{ITEMS}} Items selected',
            SELECTEDSINGLE: '{{ITEMS}} Item selected',
            TOTALCUSTOMERS: 'Total Customers',
            VALUE: 'Value',
            CUSTOMER_DETAILS_TITLE: 'Customer details',
            CUSTOMER_DETAILS_TITLE_SHORT: 'Customer'
        },
        DISCOUNTADD: {
            AND: 'and',
            ANDAPPLYITTO: 'and apply it to',
            AT_CHECKOUT: 'at checkout.',
            CHAR_MAX: '20 Character Max',
            COMMA: ',',
            CREATETHISDISCOUNT: 'Create this discount',
            DAYS: 'days',
            DISCOUNT: 'discount',
            DOLLAR: 'dollar',
            DOLLARSIGN: '$',
            HAVE_LIMIT: 'have a limit of',
            HAVE_A_LIMITED_DURATION: 'have a limited duration',
            HAVE_A_LIMITED_DURATION_PUNCTUATED: 'have a limited duration.',
            IWANTTOOFFERA: 'I want to offer a',
            MONTHS: 'months',
            MYENTIRESTORE: 'my entire store',
            NAME_HELP: 'which will be displayed at checkout.',
            NO_CODE: 'require a code at checkout.',
            OF: 'of',
            PERCENT: 'percent',
            PERCENT_SYMBOL: '%',
            PERIOD: '.',
            REQUIRE_CODE: 'require the code',
            SELECTCATEGORIESPRODUCTS: 'Select categories/products...',
            SPACEOF: 'of',
            THEDISCOUNT: 'The discount',
            THE_DISCOUNT_WILL_BE_NAMED: 'The discount will be named',
            TITLE: 'Add Discount',
            USES: 'uses',
            WILL: 'will',
            WILLNOT: 'will not'
        },
        DISCOUNTEDIT: {
            ACTIVATE: 'Active',
            ACTIVATEYOURDISCOUNT: 'Please activate your discount to be used in checkout.',
            APPLYTOENTIRESTORE: 'Apply discount to entire store',
            DOLLARS: 'Dollars ($)',
            DURATION: 'Duration',
            DURATIONDESCRIPTION: 'Select the start and end times for the discount.',
            ENDED: 'Ended',
            ENDS: 'Ends',
            ERROR_DELETE: 'There was a problem deleting this discount.',
            ERROR_SAVING: 'There was a problem saving this discount. Please check the quantities in the Rules card.',
            ERROR_TITLE: 'Error',
            MAX: 'maximum',
            MAX_LIMIT: 'Limit discount to',
            MIN: 'minimum',
            MINIMUM_QUANTITY: 'Minimum Quantity',
            NOORDERS: 'No orders have been placed with this discount.',
            ORDERMETRICS: 'This discount has been used for <a href="order/list?search=discount:{{code}}" class="discount-card__orders-link" id="discount-details_filter-orders_link">{{ orderCount }} orders</a>, totaling {{ totalOrderAmount | currency }}. Shoppers using this discount have saved a total of {{ totalDiscountAmount | currency }}, with an average of {{ (totalDiscountAmount / orderCount) | currency }} saved per order.',
            PERCENT: 'Percent (%)',
            PERIOD: '.',
            QUANTITY: 'quantity',
            REQUIRES: 'Discount requires a',
            REQUIRES_CODE: 'Discount requires code',
            RULES: 'Rules',
            RULES_DESCRIPTION: 'These conditions must be met to apply this discount.',
            SCOPE: 'Scope',
            SCOPE_CHANGE_ALERT: 'You will not be able to apply a minimum quantity requirement to more than one product.',
            SELECT_SHORT: 'Selected product/categories',
            SELECTTHECATEGORIESPRODUCTS: 'Select the categories and/or products to which you\'d like to apply the discount.',
            SINGLE_ORDERMETRIC: 'This discount has been used for <a href="order/list?search=discount:{{code}}" class="discount-card__orders-link" id="discount-details_filter-orders_link">{{ orderCount }} order</a>, totaling {{ totalOrderAmount | currency }}. The shopper using this discount has saved {{ (totalDiscountAmount / orderCount) | currency }}.',
            STARTS: 'Starts',
            STATUS: 'Status',
            TITLE: 'Discount Details',
            TOTALPRODUCTSDISCOUNTED: 'Total products discounted:',
            USAGE: 'Usage Limits',
            USAGE_DESCRIPTION: 'Restrict the number of times this discount can be used at checkout.',
            USAGESTATUS: 'Remaining uses:',
            USE_AMBIGUOUS: 'use(s)',
            USE_PLURAL: 'uses',
            USE_SINGULAR: 'use'
        },
        DISCOUNTFIELDS: {
            CODE: 'Code',
            DISCOUNTTYPE: 'Discount type',
            DURATION: 'Duration',
            DURATIONLENGTH: 'Duration length',
            DURATIONUNITS: 'Duration units',
            ERROR_CODE_REQUIRED: 'Discount code is required',
            ERROR_CODE_TAKEN: 'Discount code is already taken',
            ERROR_DURATION_MAX: 'Duration cannot be greater than 1000',
            ERROR_DURATION_MIN: 'Duration must be greater than 0',
            ERROR_DURATION_REQUIRED: 'Duration length is required',
            ERROR_ENDDATE_FORMAT: 'Invalid format',
            ERROR_ENDDATE_MINDATE: 'Min date',
            ERROR_ENDDATE_REQUIRED: 'This is required',
            ERROR_FIXEDREDUCTION_MIN: 'Price reduction must be greater than 0',
            ERROR_FIXEDREDUCTION_REQUIRED: 'Price reduction amount is required',
            ERROR_INVALID_MAX_QUANTITY: 'Must be greater than the minimumquantity',
            ERROR_INVALID_MAX_QUANTITY_GT_ZERO: 'Maximum quantity must be greater than 0',
            ERROR_INVALID_MIN_QUANTITY: 'Minimum quantity must be greater than 1',
            ERROR_INVALID_MIN_QUANTITY_LTE_MAX: 'Minimum quantity must be less than or equal to the maximum quantity',
            ERROR_NAME_REQUIRED: 'Discount name is required',
            ERROR_PERCENTREDUCTION_MAX: 'Percentage cannot be greater than 100',
            ERROR_PERCENTREDUCTION_MIN: 'Price reduction must be greater than 0',
            ERROR_PERCENTREDUCTION_REQUIRED: 'Price reduction amount is required',
            ERROR_STARTDATE_FORMAT: 'Invalid format',
            ERROR_STARTDATE_MINDATE: 'Min date',
            ERROR_STARTDATE_REQUIRED: 'This is required',
            ERROR_USAGELIMIT_MAX: 'Usage limit must be less than 9,999,999',
            ERROR_USAGELIMIT_MIN: 'Usage limit must be greater than 1',
            ERROR_USAGELIMIT_REQUIRED: 'Usage limit is required',
            ERROR_USAGESCOPE_REQUIRED: 'Usage scope is required',
            LIMIT_TOTAL_USES: 'Limit total number of uses',
            LIMIT_CUSTOMER_USES: 'Limit number of uses per customer',
            MIN_QUANTITY: 'Minimum quantity',
            MIN_QUANTITY_REQUIRED: 'Minimum quantity required',
            NAME: 'Name',
            PRICEREDUCTION: 'Price reduction',
            SCOPE: 'Scope',
            STATUS: 'Status',
            UNLIMITEDDURATION: 'Unlimited duration',
            USAGE: 'Usage',
            USAGE_LIMIT_TOTAL: 'Total usage limit',
            USAGE_LIMIT_CUSTOMER: 'Per customer limit',
            VALUE: 'Value'
        },
        DISCOUNTLIST: {
            ACTIVEDISCOUNTS: 'Active Discounts',
            ADD: 'Add Discount',
            ALLDISCOUNTS: 'All Discounts',
            INACTIVEDISCOUNTS: 'Disabled Discounts',
            NODISCOUNTS: 'No discounts found.',
            SELECTEDPLURAL: '{{ITEMS}} Items selected',
            SELECTEDSINGLE: '{{ITEMS}} Item selected',
            TITLE: 'Discounts',
            TOTALAMOUNTSAVEDMETRICLABEL: 'Total Amount Saved',
            TOTALDISCOUNTSMETRICLABEL: 'Total Discounts',
            TOTALUSESMETRICLABEL: 'Total Number of Uses',
            WILLAPPEAR: 'Click + to start adding discounts.'
        },
        EDITSTORECONTENT: {
            404: '404',
            ADD: 'Add Item',
            ALT: 'Alt',
            CANCEL: 'Cancel',
            CATEGORY: 'Category',
            DELETE: 'Clear',
            EDIT: 'Edit',
            FACEBOOK: 'Facebook URL',
            GOOGLE: 'Google+ URL',
            HOME: 'Home',
            INSTAGRAM: 'Instagram URL',
            LASTUPDATED: 'Last updated',
            LINK: 'Link',
            LINKTO: 'Link to',
            LINKURL: 'Link URL',
            MENUSEMPTYTEXT: 'Add a category, product, page or custom link to your menu. To rearrange the order, just drag and drop the item.',
            MENUSEMPTYTITLE: 'Your menu is empty!',
            NEWITEMLABEL: 'Link Text',
            NOMATCHES: 'No matches found.',
            NOSETTINGSFORPAGE: 'No settings for current page',
            OUTOFDATEURL: 'The resource you have linked to has changed or moved.',
            PAGE: 'Page',
            PINTEREST: 'Pinterest URL',
            PRODUCT: 'Product',
            SAVE: 'Save',
            SEARCHRESULTS: 'Search results',
            SELECTPAGE: 'Select a page',
            SOCIAL: 'Social',
            STORENAME: 'Store Name',
            TITLE: 'Content',
            TWITTER: 'Twitter URL',
            UNSAVEDCHANGESCONTENT: 'Save your changes?',
            UNSAVEDCHANGESDONTSAVE: 'Don\'t save',
            UNSAVEDCHANGESSAVE: 'Save',
            UNSAVEDCHANGESTITLE: 'Unsaved Changes',
            URL: 'External URL'
        },
        EDITSTORELANDING: {
            CONTENT: 'Content',
            CONTENTDESCRIPTION: 'Customize your theme’s text, images and settings.',
            LOGO: 'Logo',
            LOGODESCRIPTION: 'Update your store name and logo.',
            MENU: 'Menu',
            MENUDESCRIPTION: 'Update your store\'s navigation menu.',
            STYLES: 'Styles',
            STYLESDESCRIPTION: 'Update colors and fonts, or even add your own custom CSS!',
            THEMES: 'Themes',
            THEMESDESCRIPTION: 'Update your active theme, or visit the Theme Store to check out more options.'
        },
        ERROR: {
            ADDRESSREQUIRED: 'Address is required',
            COUNTRY_REQUIRED: 'Country is required',
            CSVVALIDATION: 'File must be a .csv',
            CSVVALIDATIONSIZE: 'File too large, must be less than {{max}}.',
            DISCOUNTCREATION: 'There was an error creating the discount',
            DOMAINAMEINVALID: 'Subdomains must be less than 64 characters and may contain only letters, numbers, and dashes (-), but cannot start or end with a dash',
            DOMAINAMEREQUIRED: 'Domain name is required',
            DOMAINAMETAKEN: 'Domain name taken',
            EMAILPATTERN: 'A valid email is required',
            EMAILREQUIRED: 'Email is required',
            FIRSTREQUIRED: 'First name is required',
            GENERAL_DESCRIPTION: 'Sorry, something went wrong. Please try again.',
            GENERAL_FAILURE_ERROR: 'Sorry, something went wrong. Please contact Volusion Customer Service.',
            GENERAL_MISSING_REQUIRED_DATA: 'Sorry, some required data is missing. Please review.',
            GENERAL_OK_BUTTON: 'Ok',
            GENERAL_TITLE: 'This is embarrassing.',
            IMAGELIMITREACHED: 'You have reached the image upload limit.',
            IMAGEVALIDATION: 'Images must be a valid type (.jpg, .jpeg, .png, .gif) and under 5mb.',
            INVALID_PRODUCT: 'Product is invalid.',
            INVENTORY_QUANTITY_MAX: 'Quantity must be less than {{MAX_VALUE}}',
            INVENTORY_QUANTITY_MIN: 'Quantity must be greater than {{MIN_VALUE}}',
            INVENTORY_START_QUANTITY_REQUIRED: 'Starting quantity is required',
            INVENTORY_UPDATE_QUANTITY_REQUIRED: 'Quantity is required',
            NAMEMAXLENGTH: 'name must be less than {{COUNT}} characters',
            NAMEREQUIRED: 'Name is required',
            PAGETITLEREQUIRED: 'Page title is required',
            PRICEREQUIRED: 'Price is required',
            SALE_PRICE_BY_PRICE: 'Sale price cannot be greater than regular price',
            SKUREQUIRED: 'SKU is required',
            STATE_REQUIRED: '{{PROVINCE_TYPE}} is required',
            USZIP: 'A valid ZIP code is required',
            VALIDPHONE: 'Please enter a valid phone number',
            VARIANT_DUPLICATE_SKU_CONFLICT: 'Sorry, a duplicate variant SKU already exists in another product.  Please review and update the variants section below before saving.',
            VARIANTNAMEREQUIRED: 'Variant name is required',
            VARIANTVALUESREQUIRED: 'Variant values are required',
            WEIGHTRANGE: 'Weight must be between 0 and 1000 inclusive',
            YOUTUBEEMBED: 'must be valid youtube url',
            ZIPREQUIRED: 'ZIP code is required'
        },
        ERRORPAGE: {
            LOGOUT: 'Logout',
            MESSAGE: 'Something went wrong on our end.',
            REFRESH: 'Refresh',
            SESSIONTIMEOUT: 'For your security, you have been logged out due to inactivity',
            STATUSPAGE: 'View Status Page',
            TITLE: 'Whoops!'
        },
        FACEBOOKPIXEL: {
            DESCRIPTION: 'The Facebook pixel is an analytics tool that allows you to measure the effectiveness of your advertising by understanding the actions people take on your website.',
            HEADING: 'Measure the results of your ads by using Facebook Pixel',
            INPUT_LABEL: 'Facebook Pixel Tracking ID',
            INPUT_PLACEHOLDER: 'Paste Pixel ID here',
            LINK: 'How do I set this up?',
            TITLE: 'Facebook Pixel'
        },
        FRAUD: {
            AVS_CHECK: 'AVS Check',
            AVS_CHECK_FAILED: 'AVS check failed',
            AVS_CHECK_UNAVAILABLE: 'AVS check unavailable',
            AVS_DESCRIPTION: 'Address Verification System (AVS) is used to verify the address of a person claiming to own a credit card. It is comprised of a ZIP code check and a street address check. Gift cards may result in failed AVS checks.',
            AVS_VALUE_UNAVAILABLE: 'Unavailable',
            AVS_ZIP_CHECK_NO: 'Zip code not verified',
            AVS_ZIP_CHECK_YES: 'Zip code verified',
            AVS_ADDRESS_LINE1_CHECK_NO: 'Address not verified',
            AVS_ADDRESS_LINE1_CHECK_YES: 'Address verified',
            BILL_SHIP_MISMATCH: 'Billing and Shipping address mismatch',
            CVC_CHECK_FAILED: 'CVC check failed',
            CVC_CHECK_UNAVAILABLE: 'CVC check unavailable'
        },
        FULFILLEREDIT: {
            CONTACT: 'Contact Information',
            EMAILDESCRIPTION: 'Enter the fulfillment service\'s contact information for quick access when fulfilling orders.',
            METHOD: 'Fulfillment Method',
            METHODDESCRIPTION: 'Select how this service will handle ordered items as they are fulfilled.',
            METHODEMAILDESCRIPTION: 'An email summarizing the ordered items will be sent to the service via the order email address. Label purchasing is disabled.',
            METHODEMAILHEADING: 'Automated Email',
            METHODMANUALDESCRIPTION: 'Use this method to manually separate the ordered items from the local inventory. You will be able to purchase a shipping label for these items.',
            METHODMANUALHEADING: 'Manual',
            NO_PRODUCTS: 'No products',
            OPTIONAL: '(optional)',
            PRODUCT: 'Product',
            PRODUCTDESCRIPTION: 'These are the products in your store associated with this fulfillment service. You can add the products to the service manually here, or within the product details page of any individual product.',
            PRODUCTHEADING: 'Serviced Products',
            PRODUCTS: 'Products',
            SUMMARY_PRICE_HEADING: 'Price',
            SUMMARY_PRODUCT_HEADING: 'Product Name',
            TITLE: 'Update Fulfillment Service'
        },
        FULFILLERFIELDS: {
            EMAIL_CONTACT: 'Email address (for contacting)',
            EMAIL_ORDER: 'Email address (for order submission)',
            ERROR_NAME_REQUIRED: 'Fulfillment Service name is required',
            HASADDRESS: 'This fulfillment service has a physical address',
            ITEMS_NUMBER_LABEL: '# of Items',
            METHOD_LABEL: 'Fulfillment Method',
            NAME: 'Name',
            NAME_LABEL: 'Service Name',
            PHONE: 'Phone number',
            TYPE_LABEL: 'Service Type'
        },
        FULFILLERLIST: {
            ADD: 'Add Service',
            ALLFULFILLERS: 'All Services',
            APPFULFILLERS: 'App',
            CUSTOMFULFILLERS: 'Custom',
            CUSTOMSERVICE: 'Custom Fulfillment Service',
            CUSTOMSERVICEBUTTON: 'Create Custom Service',
            CUSTOMSERVICEDESCRIPTION: 'Create acustom service that can send an email with the order details to a specified email address.',
            LANDINGDESCRIPTION: 'Fulfillment services are warehouses and drop shipping providers who can prepare and ship your orders. If you\'ve grown beyond your capabilities and can\'t ship your orders, or you just don\'t want to deal with shipping at all, try these services or create your own.',
            LANDINGHEADING: 'Add and manage your order fulfillment services',
            NOFULFILLERS: 'No fulfillment Services found.',
            SELECTEDPLURAL: '{{ITEMS}}Items selected',
            SELECTEDSINGLE: '{{ITEMS}} Item selected',
            TITLE: 'Fulfillment Services',
            WILLAPPEAR: 'Click + to start adding Fulfillment Services.'
        },
        FULLSTORY: {
            DESCRIPTION: 'Every click, keypress, page transition and more - automatically recorded so you can play it back and watch a video of how your customers are interacting with your site.',
            ERROR_MESSAGE: 'Looks like you added too much. Just add your Organization ID.',
            HEADING: 'FullStory captures your customer\'s experience using your website.',
            INPUT_LABEL: 'FullStory Organization ID',
            INPUT_PLACEHOLDER: 'Paste Fullstory Organization ID here',
            LINK: 'How do I set this up?',
            REQUIRED: 'A Fullstory Organization ID is required.',
            TITLE: 'Fullstory'
        },
        GETTING_STARTED: {
            EMAIL_VERIFIED_COMPLETE: 'Your email is verified',
            HEADLINE: 'Get Started',
            PHONE_NUMBER: 'tel:8775102334',
            SAVE_STORE_NAME: 'Save store name',
            SECTION_ADD_PRODUCTS_TITLE: 'Add some products',
            SECTION_CHOOSE_THEME_TITLE: 'Choose a new theme design',
            SECTION_CONFIGURE_SETTINGS_TITLE: 'Configure your store settings',
            SECTION_HERE_TO_HELP_TITLE: 'We\'re here to help!',
            SECTION_STORE_NAME_TITLE: 'Name your Volusion store',
            SECTION_TRIAL_STARTED_TITLE: 'Start your free trial',
            SECTION_VIEW_STOREFRONT_TITLE: 'Check out your storefront',
            STORE_NAME_SAVED: 'Updated store name',
            SUBHEADING: 'Volusion\'s simple store setup.',
            TASK_CALL: 'Call us (877) 510-2334',
            TASK_CHAT: 'Chat with an expert now',
            TASK_GO_TO_SETTINGS: 'Go to Settings',
            TASK_GO_TO_THEMES: 'Go to Theme Store',
            TASK_NAME_STORE: 'Set your store\'s name',
            TASK_VIEW_STOREFRONT: 'View Storefront',
            UPDATING_STORE_NAME: 'Updating Store Name'
        },
        GREETING: {
            HAPPENINGTODAY: 'Here’s what’s happening with your store today.',
            FIRSTTIME: 'Welcome back.',
            WELCOME: 'Welcome to Volusion, {{NAME}}',
            WELCOME_GETSTARTED: 'Get started with our simple store setup.',
            GOODAFTERNOON: 'Good afternoon, {{NAME}}.',
            GOODAFTERNOON_NONAME: 'Good afternoon.',
            GOODEVENING: 'Good evening, {{NAME}}.',
            GOODEVENING_NONAME: 'Good evening.',
            GOODMORNING: 'Good morning, {{NAME}}.',
            GOODMORNING_NONAME: 'Good morning.'
        },
        HELP_ACTIONS: {
            CALL: 'Schedule a call',
            CHAT: 'Message us',
            DOCS: 'Help Center'
        },
        IMAGE: {
            ALTTEXT: 'Alt Text',
            DESCRIPTION: 'Description',
            METADATATITLE: 'Image Attributes',
            TITLE: 'Title'
        },
        IMAGELIBRARY: {
            ALLIMAGES: 'All images',
            CANCEL: 'Cancel',
            CLIPBOARDSUCCESS: 'Link copied to clipboard',
            DELETE: 'Delete',
            DELETECONFIRMATION: 'Are you sure you want to delete',
            DELETEMESSAGE: 'This cannot be undone. If in use, the images will no longer appear on your storefront.',
            DELETESUCCESS: 'deleted successfully',
            DISMISS: 'Dismiss',
            IMAGE: 'image',
            IMAGES: 'images',
            IN: 'in',
            IUNDERSTAND: 'I understand',
            MORE: 'More',
            NOIMAGES: 'You don\'t have any images',
            RECENTLYUSED: 'Recently used',
            SELECTALL: 'Select all',
            SELECTED: 'selected',
            SELECTFROMLIBRARY: 'Select from gallery',
            SELECTNONE: 'Select none',
            TITLE: 'Image Gallery',
            TOOLTIPCLIPBOARD: 'Copy image URL to clipboard',
            TOOLTIPDELETE: 'Delete selected images',
            TOOLTIPEDIT: 'Edit image',
            UPLOAD: 'Upload',
            UPLOADLIMIT: 'You have reached the image upload limit.',
            USE: 'Use'
        },
        IMPORTER_MODULE: {
            TITLE: '{{IMPORTER_TYPE}} Importer',
            IMPORT_TYPES: 'Import {{IMPORTER_TYPE}}s',
            CHOOSE_FILE: 'Choose File',
            DRAG_AND_DROP: 'Drag & drop to upload',
            DROP: 'Drop here to select',
            ERROR_DISMISS: 'Dismiss',
            ERROR_VIEW_REPORT: 'View {{IMPORTER_TYPE}} import error report',
            HELP: 'Download our sample CSV to use as a template for importing your new {{IMPORTER_TYPE}}s. If you do not have the required extensions installed, the importer will install them for you.',
            IMPORTING: 'Importing your {{IMPORTER_TYPE}}s...',
            SAMPLE_CSV: 'Download our sample CSV template',
            SUCCESS_IMPORTED: '{{COUNT}} of {{ATTEMPTED}} new {{IMPORTER_TYPE}}s imported.',
            SINGLE_ERROR: 'Unfortunately, we encountered an error while importing:',
            MULTIPLE_ERRORS: 'Unfortunately, we encountered multiple errors while importing:'
        },
        INVENTORY: {
            ADDBUTTONLABEL: 'Add',
            BASEPRODUCTSKU: 'Base Product SKU',
            BASESKU: 'SKU',
            CARDTITLE: 'Inventory',
            INSTRUCTIONS: 'Manage the stock status and SKUs for your products. With the variants extension installed, you can manage each individual variant’s inventory.',
            SETBUTTONLABEL: 'Set',
            STARTQUANTITYLABEL: 'Quantity',
            STARTQUANTITYPLACEHOLDER: 'Starting quantity',
            STARTTRACKING: 'Start Tracking Inventory',
            UPDATEBUTTONLABEL: 'Update',
            UPDATEQUANTITYLABEL: 'Update Quantity',
            UPDATEQUANTITYPLACEHOLDER: 'Update Quantity',
            VARIANTSMESSAGE: 'Product quantities controlled in the variants section'
        },
        INVOICE: {
            AMOUNT: 'Amount',
            BALANCE_DUE: 'Balance Due',
            CANCEL: 'Cancel',
            CARD_CHARGE_MESSAGE: 'Your {{CARDTYPE}} ending in {{LASTFOUR}} will be automatically charged on {{CHARGEDATE}}.',
            CHANGE: 'Change',
            CHARGES: 'Charges',
            CLOSED: 'Closed',
            CONFIRM_AND_PAY: 'Confirm and Pay',
            CONFIRM_PAYMENT: 'Confirm Payment',
            CONFIRM_PAYMENT_DETAILS: 'Please confirm your payment details.',
            CREDIT: 'Credit',
            CREDIT_WILL_BE_APPLIED: 'Your credit will be applied to the next invoice.',
            CURRENCY: '$',
            DATE: 'Date',
            DETAILS: 'Details',
            DISCOUNT: 'Discount',
            DISCOUNTS: 'Discounts',
            DOWNLOAD: 'Download',
            ENDING_IN: 'ending in',
            EXPIRES: 'Expires:',
            FORGIVEN: 'Forgiven',
            INVOICE: 'Invoice',
            INVOICEITEM: 'Subscription',
            INVOICENUMBER: 'Invoice Number',
            INVOICES: 'Billing',
            NOINVOICESHEAD: 'No invoices to display',
            NOINVOICESSUBHEAD: 'Check back after your first invoice is issued.',
            NOTPAIDACCOUNT: 'Balance due will be updated after your first invoice is issued.',
            NUMBER: 'Number',
            PAID: 'Paid',
            PAID_ERROR: 'Sorry, there was an error with your payment.',
            PAID_SUCCESS: 'Payment Successful!',
            PAY_BALANCE_NOW: 'Pay Balance Now',
            PAYMENT_METHOD: 'Payment Method',
            PAYNOW: 'Pay Now',
            PLUSPLAN: 'Plus Plan',
            PLUSPLANURL: '({{URL}})',
            SERVICEPERIOD: 'Service Period',
            SHIPPINGDETAILS: 'Combined postage purchased',
            SHIPPINGITEM: 'Postage',
            STATUS: 'Status',
            TAX: 'Tax',
            TOTAL: 'Total',
            UNPAID: 'Unpaid',
            UNPAID_INVOICE: 'You have one unpaid invoice.',
            UNPAID_INVOICES: 'You have {{UNPAIDCOUNT}} unpaid invoices.',
            UPCOMING: 'Upcoming',
            UPCOMING_NUMBER: '--'
        },
        LABEL: {
            ADDAPP: 'add an app',
            ANALYTICS: 'Analytics',
            AMAZON: 'Amazon',
            APPSTORE: 'Integrations',
            BLOCK_MANAGEMENT: 'Blocks',
            CART: 'Cart',
            CATEGORIES: 'Categories',
            CLOSE_VIDEO: 'Video',
            CREATED: 'Created',
            CURRENCY: '$',
            CUSTOMERNOTE: 'Customer Note',
            CUSTOMERS: 'Customers',
            DELETE: 'Remove',
            DESCRIPTION: 'Description',
            DESKTOPWIDTH: 'Desktop width',
            DISCOUNTS: 'Discounts',
            DUPLICATE: 'duplicate',
            EDITSTORE: 'Store Editor',
            EMAIL: 'Email',
            EXPORT_PRODUCTS: 'Export Products to CSV',
            FACEBOOKPIXEL: 'Facebook Pixel',
            FULFILLERS: 'Fulfillment Services',
            FULLSCREEN: 'Fullscreen',
            FULLSTORY: 'Fullstory',
            GET_STARTED: 'Get Started',
            GOOGLEANALYTICS: 'Google Tracking',
            GRANDTOTAL: 'Grand Total',
            CHAT: 'Live Chat',
            HOME: 'Home',
            ITEMPRICE: 'Item Price',
            ITEMSTOTAL: 'Items total',
            LASTMODIFIED: 'Last Modified',
            MAILCHIMP: 'MailChimp',
            MENU_MANAGEMENT: 'Menu Editor',
            MOBILEWIDTH: 'Mobile width',
            NAME: 'Name',
            OPTIONAL: '(optional)',
            ORDERS: 'Orders',
            PAGES: 'Pages',
            PINTEREST: 'Pinterest',
            PRICE: 'Price',
            PRICEEACH: 'Price Each',
            PRINTIFY: 'Printify',
            PRIVY: 'Privy',
            PRODUCTS: 'Products',
            QTY: 'Qty',
            QUANTITY: 'quantity',
            QUICKBOOKS: 'Quickbooks',
            SAVE: 'Save',
            SHIPPING: 'Shipping',
            SITE_DESIGNER: 'Site Designer',
            STORECREDIT: 'Gift Cards',
            STORESETTINGS: 'Settings',
            SUBTOTAL: 'Subtotal',
            TABLETWIDTH: 'Tablet width',
            TAXES: 'Taxes',
            THEMEPREVIEW: '{{TITLE}} Theme Preview',
            THEMESTORE: 'Theme Store',
            UPDATED: 'Updated',
            USER_PERMISSIONS: 'Users & Permissions',
            VALUE: 'Value',
            WATCH_VIDEO: 'Watch the video',
            XERO: 'XERO',
            YOTPO: 'Yotpo',
            ZAPIER: 'Zapier',
            AVALARA: 'Avalara',
            SITE_TAGGING: 'Site Tagging'
        },
        LEAVE: {
            AREYOUSURE: 'Sure you want to leave?',
            CONTINUE: 'Continue',
            UNSAVEDCHANGES: 'You have unsaved changes.'
        },
        LOGIN: {
            ACCOUNTNOTFOUND: 'No account found',
            CHECKEMAIL: 'Check your email to finish password reset.',
            COOKIESREQUIRED: 'Enable cookies to log in.',
            EMAIL: 'Email Address',
            EMAILREQUIRED: 'Email is required',
            EMAILTAKEN: 'That email is already being used',
            EMAILVALID: 'A valid email is required',
            ERRORRESET: 'Can\'t reset password. Try again later.',
            FIRSTNAME: 'First Name',
            FORGOTPASSWORD: 'Forgot password?',
            HAVEANACCOUNT: 'Have an account?',
            IMPERSONATING: 'Logging you in for concierge session',
            INVALIDLOGIN: 'A valid username or password is required',
            LASTNAME: 'Last Name',
            LOGGINGIN: 'Logging you in',
            LOGIN: 'Log in',
            OR: 'or',
            PASSLENGTH: 'Use more than {{COUNT}} characters',
            PASSREQUIRED: 'Password is required',
            PASSVALID: 'Use 1 lowercase letter, 1 uppercase letter, and either a number or a special character',
            PASSWORD: 'Password',
            PASSWORDRESET: 'Password successfully reset. Log in to continue.',
            RESETPASSWORD: 'Reset Password',
            RESETTINGPASSWORD: 'Resetting password',
            SETTINGUPSTORE: 'Just a moment while we set up your store',
            SETTINGUPSTORESUCCESS: 'Congratulations, your store is ready! Sign in with Google one more time to finalize your account setup.',
            SIGNINWITHGOOGLE: 'Sign In With Google',
            SOCIALLOADING: 'Just a moment',
            TOOMANYATTEMPTS: 'Your account is blocked. Check your email.',
            UNKNOWNSERVERERROR: 'Server Error. Try again later.',
            PASSWORDEXPIRED: 'Your password has expired. Please enter your email below to reset your password.',
            VALIDATED: 'Your email address has been verified.'
        },
        MODAL: {
            CANTUNDO: 'This cannot be undone.',
            DELETE: 'Remove {{COUNT}} {{TYPE}}?',
            DUPLICATE: 'Copy {{COUNT}} {{TYPE}}?'
        },
        MYACCOUNT: {
            CANCEL: 'Cancel',
            CANCEL_MY_STORE: 'Cancel My Store',
            CHANGE: 'Change',
            CHANGEPASSWORD: 'Change password',
            DELETEMYSTORE: 'Delete my store',
            EMAIL: 'Email',
            EMAILREQUIRED: 'Email is required',
            EMAILTAKEN: 'That email is already being used',
            FIRSTNAME: 'First Name',
            LASTNAME: 'Last Name',
            NEWPASSWORD: 'New password',
            OLDPASSWORD: 'Old password',
            PASSWORD: 'Password',
            PASSWORDERROR: 'Can\'t update password. Try again.',
            PASSWORDMATCH: 'Passwords don\'t match',
            PASSWORDREQUIRED: 'Password is required',
            PASSWORDVALID: 'Use 1 lowercase letter, 1 uppercase letter, and either a number or a special character',
            PAYMENTMETHOD: 'Payment Method',
            PLUSFEATURES: 'Custom Domain_Bulk Product Import_Unlimited Products_Unlimited Image Uploads',
            PROFILE: 'Profile',
            REPEATPASSWORD: 'Confirm password',
            TITLE: 'My Account',
            UPDATEAVATAR: 'Update Avatar',
            VALIDEMAIL: 'A valid email is required'
        },
        NOTIFICATION: {
            DISMISS: 'Dismiss',
            ENABLE: 'Turn On',
            NEWORDER: 'New Order from {{STORE}}.',
            NEWORDERNOSTORENAME: 'New Order from Your Store',
            REQUEST: 'Turn on desktop notifications.',
            RESEND: 'Resend',
            RESENT: 'Re-sent',
            THEMEUPDATEMESSAGE: 'Your current theme has an update available!',
            UPDATE: 'Update',
            UPDATENOW: 'Update Now'
        },
        ONBOARDING: {
            ADDPRODUCT_TITLE: 'Add Products',
            CONGRATS_GETSELLING: 'Let\'s Get Selling!',
            CONGRATS_OPEN: 'Your store is now open tothe world!',
            CONGRATS_YOURLIVE: 'Congratulations, you\'re live!',
            LAUNCHSTORE_COMPLETETITLE: 'Store Launched!',
            LAUNCHSTORE_TITLE: 'Launch Store',
            READYTOLAUNCH_DESCRIPTION: 'Since you\'ve completed the required actions, you can launch your store and open it to the world! If you\'re not ready yet, you can come back and launch later.',
            READYTOLAUNCH_TITLE: 'You\'re ready to launch!',
            SECTION_LAUNCH_DESCRIPTION: 'Complete these steps to launch your store.',
            SECTION_LAUNCH_TITLE: 'Launch Status',
            SENDING_VERIFICATION_EMAIL: 'Sending verification email...',
            SENT_VERIFICATION_EMAIL: 'Verification email sent!',
            VERIFICATION_EMAIL_TOAST: 'Re-sent verification email.',
            VERIFYEMAIL_TITLE: 'Verify your email address'
        },
        ORDER: {
            ACCEPT_BULK_PAYMENT: 'You\'re about to accept payment for {{COUNT}} {{TYPE}}.',
            ACCEPT_BULK_PAYMENT_SUCCESS: 'Payment accepted on {{COUNT}} {{TYPE}}.',
            ACCEPT_PAYMENT: 'Accept Payment',
            ADD: 'Add an Order',
            ADDCHARGE: 'Add Charge',
            ADD_INTERNAL_NOTES: 'Add internal notes...',
            ADDPRODUCTS: 'Add Products to Order',
            ADDPROMOCODE: 'Add Promo Code',
            ADDGIFTCARD: 'Add Gift Card',
            ADD_TRACKING: 'Add Tracking Info',
            ADJUSTMENTCHARGE: 'Adjustment Charge',
            ALLORDERS: 'All Orders',
            ALREADY_PAID: '{{COUNT}} {{TYPE}} you selected are already paid. No action will be taken on them.',
            AMOUNT: 'Amount',
            AMOUNTISREQUIRED: 'Amount is required',
            ARCHIVED: 'Archived',
            BILLING: 'Billing',
            BILLING_ADDRESS_UPDATED: 'Billing address updated',
            BILLINGADDRESS: 'Billing Address',
            BILLTO: 'Bill To',
            BROWSE_PRODUCTS: 'Browse Products',
            BULK_PROCESS_CHECKLIST_TRACKING: 'Tracking number added',
            BULK_PROCESS_CHECKLIST_PAYMENT: 'Payment Received',
            BULK_PROCESS_CHECKLIST_SHIPPED: 'Shipping confirmation sent',
            BULK_PROCESS_CHECKLIST_FULFILLED: 'Mark as fulfilled',
            BULK_PROCESS_CHOOSE_FILE: 'Choose File',
            BULK_PROCESS_DRAG_AND_DROP: 'Drag & drop to upload',
            BULK_PROCESS_DROP: 'Drop here to select',
            BULK_PROCESS_ERROR_DESCRIPTION: 'Error Description',
            BULK_PROCESS_ERROR_HEADING: 'We encountered {{COUNT}} {{TYPE}} while importing:',
            BULK_PROCESS_ERROR_REPORT: 'Error Report',
            BULK_PROCESS_HELP: 'This will automatically process many orders at once by updating orders with a tracking number, capture payment, send a shipping confirmation email, and mark the orders as fulfilled.',
            BULK_PROCESS_IMPORTING: 'Importing yourorders...',
            BULK_PROCESS_IMPORT_BUTTON: 'Import Orders',
            BULK_PROCESS_LINE_NUMBER: 'Line #',
            BULK_PROCESS_OR: 'or',
            BULK_PROCESS_ORDERS: 'Bulk Process Orders',
            BULK_PROCESS_REQUIREMENT_1: 'Maximum file size:',
            BULK_PROCESS_REQUIREMENT_1_VALUE: '5MB',
            BULK_PROCESS_REQUIREMENT_2: 'File type:',
            BULK_PROCESS_REQUIREMENT_2_VALUE: 'Comma-separated values (.csv)',
            BULK_PROCESS_RE_UPLOAD_MESSAGE: 'You can re-upload your file once you have corrected those errors.',
            BULK_PROCESS_SAMPLE_CSV: 'Download our sample CSV template',
            BULK_PROCESS_SERVER_ERROR: 'The server responded with an error. Please try again later.',
            BULK_PROCESS_SUCCESS_IMPORTED: '{{COUNT}} of {{ATTEMPTED}} orders were successful.',
            BULK_PROCESS_TITLE: 'Bulk Process Orders',
            BULK_PROCESS_VIEW_REPORT: 'View error report',
            CANCEL: 'Cancel Order',
            CANCELED: 'Canceled',
            CANCELMODAL: 'Cancel Order?',
            CANCELMODALCANCEL: 'Cancel Order',
            CANCELMODALHEADING: 'Confirm Order Cancel',
            CANCELMODALKEEPORDER: 'Keep Order',
            CANCELORDER: 'Cancel Order',
            CARDDECLINED: 'The card was declined.',
            CHARGEERROR: 'Can\'t charge card',
            CHARGEERRORDETAIL: 'Failed to Capture Charge. Authorization Expired.',
            CHARGESUCCESSFUL: 'Payment Captured',
            COMPLETED: 'Completed',
            CONTACTCUSTOMER: 'Contact customer',
            CREATED_DATE: 'Created {{DATE}}',
            CREATE_LABEL: 'Create Shipping Label',
            CREATING_FULFILLMENT: 'Creating fulfillment',
            CUSTOMERCARDPREAMBLE: 'Find an existing customer, or create a new one.',
            CUSTOMERLABEL: 'Customer',
            CUSTOMER_NOTE: 'Customer Note',
            CUSTOMER_PAID: 'Amount customer paid for shipping: {{SHIPPING}}',
            CUSTOMERSEARCHPLACEHOLDER: 'Search customers...',
            CUSTOMSHIPPING: 'Custom shipping cost',
            DATE: 'Order Placed',
            DETAILS: 'Details',
            DISCOUNT: 'Order Discount',
            DISCOUNT_TOTAL: 'Discount Total',
            DISCOUNT_CUSTOM_FIXED: '(CUSTOM {{AMOUNT}})',
            DISCOUNT_CUSTOM_PERCENT: '(CUSTOM {{AMOUNT}}%)',
            DISCOUNTPREAMBLE: 'Enter a promo code, or choose a custom discount amount.',
            DISCOUNTTYPECUSTOM: 'Custom Discount',
            DISCOUNTTYPEPROMOCODE: 'Promo Code',
            EDITORDER: 'Edit Order',
            EDIT_PRICE: 'Edit Price',
            EDIT_PRICE_INSTRUCTION: 'Editing the product price will create a custom discount. The order total will be updated to reflect your changes.',
            ENDINGIN: 'ending in',
            ENTER_NEW_PRICE: 'Enter New Price',
            ERROR_DISMISS: 'Dismiss',
            ESTIMATEDDELIVERY: 'Estimated Delivery:',
            FINISHTOACCEPT: 'Finish your PayPal account setup to accept.',
            FINISHTOSHIP: 'Finish your PayPal account setup to ship.',
            FLAGGED: 'Flagged',
            FULFILL: 'Fulfill',
            FULFILLED: 'Fulfilled',
            FULFILLING_ITEMS: 'Fulfilling Items...',
            FULFILLMENT_METHOD: 'Fulfillment Method',
            FULFILLMENT_NO_QTY: 'No Fulfillment Qty',
            FULFILLMENT_NUMBER: 'Fulfillment #{{NUMBER}}',
            FULFILLMENT_PARTIAL: 'Partial Fulfillment',
            FULFILLMENT_SERVICE: 'Shipping carrier',
            FULFILLMENT_TOTALS: 'Fulfillment totals:',
            FULFILLMENTS: 'Fulfillments',
            GIFTCARD: 'Gift Card',
            GIFTCARD_PREAMBLE: 'Enter a gift card code.',
            REMAINING_BALANCE: 'Remaining Balance',
            HASH_X: '#{{NUMBER}}',
            IMPORT_ORDERS_MENU: 'Import Orders',
            INBOX: 'Inbox',
            INPROGRESS: 'In Progress',
            INTERNALNOTE: 'Internal Notes',
            INTERNAL_NOTE: 'Notes',
            INVENTORY_ERROR: 'Inventory was exceeded.',
            INVENTORY_REMAINING: '{{QUANTITY}} in stock.',
            INVOICE: 'Invoice',
            ISSUEREFUND: 'Issue Refund',
            ITEM: 'item',
            ITEM_WEIGHT: 'Item Weight',
            ITEMDETAIL: 'Item Details',
            ITEMS: 'items',
            ITEMS_FULFILLED: 'Items Fulfilled',
            LAST30DAYS: 'Orders In Last 30 Days',
            LBS: 'lbs',
            LIST_DATE_LABEL: 'Date',
            MANUAL_TRACKING: 'Manually fulfill the ordered items and add optional tracking information.',
            MARK_FULFILLED: 'Mark as Fulfilled',
            MARK_FULFILLED_NOW: 'Mark as Fulfilled Now',
            MARKSHIPPED: 'Mark as Shipped',
            NAME: 'Order',
            NEW: 'New',
            NO_FLAGGED_ORDERS: 'No flagged orders',
            NO_TRACKING: 'No tracking information',
            NOORDERS: 'No orders found.',
            NOTE: 'note',
            NOTEADDED: 'Internal Note Added',
            NOTEREMOVED: 'Internal Note Removed',
            NOTEUPDATED: 'Internal Note Updated',
            NOTIFIED_VIA_EMAIL: 'Emailed {{TIME_AGO}}',
            NOTIFY_CUSTOMER: 'Send shipping notification to customer',
            NOTIFY_EMAIL_FULFILLER: 'Notify Fulfiller Via Email',
            NOTIFY_EMAIL_FULFILLER_SUCCESS: 'Notification has been sent via email. You can mark these items as fulfilled now, or wait for {{FULFILLER}} to send you a shipping confirmation.',
            NOTIFYING_FULFILLER_VIA_EMAIL: 'Notifying {{FULFILLER}} via email',
            NUMBER: 'Number',
            OF_QUANTITY: 'of {{QUANTITY}}',
            OPTIONAL: '(optional)',
            ORDER_FULFILLMENT: 'Order Fulfillment',
            ORDERCARDPREAMBLE: 'Search your store\'s inventory and add products to the order.',
            ORDERDATE: 'Order Date',
            ORDEREDITED: 'Order Updated',
            ORIGINAL_PAYMENT: 'Original Payment',
            ORIGINALINVOICE: 'Original Invoice',
            OVERVIEW_DATE: '{{DATE}}',
            OVERVIEW_ITEMS_TOTAL: '{{CUSTOMER}} ordered {{ITEM}} for a total of {{TOTAL}}.',
            PACKINGSLIP: 'Packing Slip',
            PAID: 'Paid',
            PARTIALLY_FULFILLED: 'Partially Fulfilled',
            PAYMENTACCEPTED: 'Payment Authorized',
            PAYMENTCAPTURED: 'Payment Captured',
            PAYMENT_CASH: 'Cash/in-person Payment',
            PAYMENT_CREDIT: 'Credit Card',
            PAYMENT_PURCHASE_ORDER: 'Purchase Order',
            PAYMENTDECLINED: 'Payment Declined',
            PAYMENTMETHOD: 'Payment Method',
            PAYMENTMETHODPREAMBLE: 'Add a payment method for this order. Payment will not be captured until after order creation.',
            PAYPALEMAILINSTRUCTIONS: 'Please verify your email with PayPal so that you can accept payments.',
            PAYPALIPNDENIED: 'Merchant denied the payment.',
            PAYPALIPNEXPIRED: 'An order or authorization has expired and can no longer be captured.',
            PAYPALIPNFAILED: 'The buyer paid by eCheck, but the attempt to withdraw the funds from the buyer’s bank account failed.',
            PAYPALIPNNONE: 'There was a problem processing payment with PayPal.',
            PAYPALIPNREVERSAL: 'The payment was reversed by PayPal.',
            PAYPALSETUP: 'Finish PayPal Setup',
            PENDING: 'Pending',
            PLURAL: 'Orders',
            PO_NUMBER: 'PO Number',
            PREAMBLEBODY: 'Manually create a new order and enter credit card payments for sales you’ve made by phone, in person, or elsewhere outside of your online store.',
            PREAMBLEHEADER: 'Create Order',
            PRICE: 'Price',
            PRICEEACHLABEL: 'Price Each:',
            PRINT_DOCUMENTS: 'Print Documents',
            PRINT_LABEL: 'Print Label',
            PRODUCT_SEARCH_PLACEHOLDER: 'Search products...',
            PROMOCODEHINT: 'Start typing to see a list of matching promo codes',
            PURCHASE_LABEL: 'Purchase and print a shipping label with discounted rates through Volusion.',
            QUANTITY: 'Quantity',
            QUANTITY_TO_FULFILL: 'Qty to Fulfill',
            QUANTITY_X: '{{QUANTITY}} x',
            REFUND: 'Mark Order as Returned',
            REFUND_LABEL: 'Refund',
            REFUNDAMOUNT: 'Refund Amount',
            REFUNDDATE: 'Refund on {{DATE}}',
            REFUNDDUE: 'Refund Due',
            REFUNDED: 'Order Refunded',
            REFUNDERROR: 'Can\'t issue a refund',
            REFUNDSUCCESSFUL: 'Refund Issued',
            REVERSECANCELED: 'Payment Reverse Canceled',
            REVIEW_EMAIL_NOTIFICATION: 'Review the ordered items and confirm the request for fulfillment. The fulfiller will be notified via email.',
            REVIEW_FULFILLMENT: 'Review the ordered items and confirm fulfillment weight. Select the quantity you\'d like to fulfill.',
            REVIEW_FULFILLMENT_NOTIFIED: 'Review the ordered items and add tracking information, if you have it.',
            SALE_ITEM: 'Sale Item',
            SAVE_PRICE: 'Save Price',
            SELECTEDPLURAL: '{{ITEMS}} Items selected',
            SELECTEDSINGLE: '{{ITEMS}} Item selected',
            SELECTPROMOCODE: 'Select a Promo Code',
            SET_UP_POSTAGE: 'Complete your setup to enable postage printing',
            SET_UP_SHIPPO: 'Go to Shippo settings',
            SHIPPED: 'Shipped',
            SHIPPING: 'Shipping',
            SHIPPING_ADDRESS: 'Shipping Address',
            SHIPPING_ADDRESS_UPDATED: 'Shipping address updated',
            SHIPPING_VIA_CARRIER: 'Shipping via {{CARRIER}}',
            SHIPPINGCARDPREAMBLE: 'Choose a shipping method and cost to assign to this product. Shipping methods are prepopulated based on the products in the order. You may also input a custom shipping cost.',
            SHIPPINGLABEL: 'Shipping Label',
            SHIPPINGMETHOD: 'Shipping Method',
            SHIPPINGMETHODPROMPT: 'Add a product and shipping address to get calculated shipping',
            SHIPPINGRATECOSTLABEL: 'Rate Cost',
            SHIPPINGRATENAMELABEL: 'Rate Name',
            SHIPPING_REQUIRED: 'Shipping carrier required if tracking number provided',
            SHIPTO: 'Shipping Address',
            SKU_LABEL: 'SKU:',
            STATUS: 'Status',
            STATUSITEM: '{{TOTAL}} item',
            STATUSITEMS: '{{TOTAL}} items',
            STATUS_FULFILLMENT: '{{TOTAL}} fulfillment,',
            STATUS_FULFILLMENTS: '{{TOTAL}} fulfillments,',
            STATUS_SOURCE: '{{TOTAL}} source,',
            STATUS_SOURCES: '{{TOTAL}} sources,',
            PAYMENTID: 'Payment ID:',
            SUBTOTAL: 'Subtotal',
            TAX: 'Tax',
            TAX_EXEMPT_INSTRUCTION: 'Choose whether or not to collect tax for this order',
            TAX_EXEMPT_SAVE: 'Set tax status',
            TAX_RECALCULATED: 'Tax recalculated',
            TAXEXEMPT: 'Order is tax exempt',
            TAXSTATUS: 'Tax Status',
            TITLE: 'Order {{NUMBER}}',
            TOTAL: 'Total',
            TOTALPRICE: 'Total Price',
            TOTAL_WEIGHT: 'Total Weight',
            TOTALAFTERREFUND: 'Total after refund',
            TOTALDUE: 'Total Due',
            TOTALORDERS: 'Total Orders',
            TRACKING_INFO: 'Tracking information',
            TRACKING_NUMBER: 'Tracking number',
            TRYAGAIN: 'Try Again',
            UNFULFILLED_ITEMS: 'Unfulfilled Items',
            UPDATEDINVOICE: 'Updated Invoice',
            VARIANTS_LABEL: 'Variants:',
            VIA_CARRIER: 'via {{CARRIER}}',
            VIEW_IN_MAP: 'View in Google Maps',
            VIEWMORECUSTOMERINFO: 'View more customer info',
            WAIT_FOR_SHIPPING_CONFIRMATION: 'Wait For Shipping Confirmation',
            WEIGHT_LBS: '{{WEIGHT}} lbs',
            WILLAPPEAR: 'When a customer makes a purchase, you can see the order here.'
        },
        PAGES: {
            ACTIVE_PAGES: 'Displayed Pages',
            ADD: 'Add Page',
            ADD_A_PAGE: 'Add a Page',
            ADDLINK: 'Add a Link',
            ALL_PAGES: 'All Pages',
            AWAITING: 'Make your site shine.',
            CONTENT: 'Pages',
            CREATE_BUTTON_LABEL: 'Create Page',
            CREATED_ON: 'Created On',
            DELETE: 'Remove this page?',
            EMBEDVIDEO: 'Embed Video',
            ENTERYOUTUBEURL: 'Please paste youtube video url or share url.',
            HIDE: 'Hide Page',
            INACTIVE: 'Hidden',
            INACTIVE_PAGES: 'Hidden Pages',
            LASTUPDATED: 'Last Updated',
            LINKLABEL: 'Link Text',
            LINKURL: 'Link URL',
            NEW_IN_LAST_30_DAYS: 'New In Last 30 Days',
            NOPAGES: 'No pages were found.',
            PAGETITLE: 'Title',
            PAGE_TITLE: 'Page Title',
            SELECTEDPLURAL: '{{ITEMS}} Items selected',
            SELECTEDSINGLE: '{{ITEMS}} Item selected',
            SHOW: 'Show Page',
            TOTAL_PAGES: 'Total Pages',
            USEFULLWIDTH: 'Use full width',
            VIDEOHEIGHT: 'Video height',
            VIDEOWIDTH: 'Video width',
            WILLAPPEAR: 'Use Pages to display anything that isn\'t a product or category. Do you have a funny mission statement? A cool story about your startup? Let the world know. Click + to start building a page.',
            YOUTUBE: 'YouTube URL'
        },
        PLACEHOLDER: {
            EMAILADDRESS: 'Email Address',
            PHONENUMBER: 'Phone Number'
        },
        POSTAGE: {
            DIMENSIONS: 'Dimensions',
            EVENT_LABELPURCHASED: 'Label purchased',
            EVENT_LABELREFUNDED: 'Label refunded',
            HEIGHTMIN: 'Height must be greaterthan 0',
            HEIGHTREQUIRED: 'Height is required',
            INCHESABREV: 'in.',
            LABEL: 'Postage Printing',
            LENGTHMIN: 'Length is required',
            LENGTHREQUIRED: 'Length must be greater than 0',
            OWNPACKAGING: 'Own packaging',
            POUNDSABREV: 'lbs.',
            USPS: 'USPS',
            WEIGHTMIN: 'Weight must be greater than 0',
            WEIGHTREQUIRED: 'Weight is required',
            WIDTHMIN: 'Width must be greater than 0',
            WIDTHREQUIRED: 'Width is required'
        },
        POSTAGEDEFAULTSEDIT: {
            LABEL_DESC: 'Prefills label printing format for all orders. You can always change it later for each order.',
            LABEL_LABEL: 'Label format',
            LABEL_TITLE: 'Default label settings',
            ORDERHANDLING_DESC: 'Set your typical order handling time for your orders. You can always change it later for each order.',
            ORDERHANDLING_LABEL: 'Order handling time',
            ORDERHANDLING_TITLE: 'Default order handling settings',
            PACKAGE_DESC: 'Prefills package type for all orders. You can always change it later for each order.',
            PACKAGE_TITLE: 'Default package settings',
            PAYMENT_TITLE: 'Payment method for label purchase',
            RETURNPOSTAGE_DESC: 'Set your preference to print return postage and set your return address.',
            RETURNPOSTAGE_SWITCH: 'Print return postage for each order.',
            RETURNPOSTAGE_TITLE: 'Return postage settings'
        },
        POSTAGEDEFAULTSSETUP: {
            ANDI: 'and I',
            BROUGHTTOYOUBY: 'Postage printing brought to you by',
            CONFIGURESETTINGS: 'Configure Settings',
            LABELFORMAT_INTRO: 'My default label format will be',
            ORDERHANDLING_DAYS: 'days.',
            ORDERHANDLING_INTRO: 'My default order handling time is',
            PACKAGE_CHOOSECARRIERPACKAGING: 'choose carrier packaging...',
            PACKAGE_INTRO: 'My default package for label purchase will be',
            PACKAGE_MYOWNPACKAGING: 'my own packaging...',
            PACKAGESETUPMODAL_ADDTITLE: 'Add default package',
            PACKAGESETUPMODAL_CANCEL: 'Cancel',
            PACKAGESETUPMODAL_DESCRIPTION: 'Prefills package type for all orders. You can always change it later for each order.',
            PACKAGESETUPMODAL_ERROR: 'Could not update address',
            PACKAGESETUPMODAL_OTHERSSOON: 'Others soon!',
            PACKAGESETUPMODAL_SAVE: 'Save package',
            PACKAGESETUPMODAL_SELECTTITLE: 'Select default package',
            PAYMENT_ENDINGIN: 'ending in',
            PAYMENT_INTRO: 'To purchase postage, I will use',
            PAYMENT_MYCARDONFILE: 'my card on file',
            PRINTRETURNPOSTAGE: 'print return postage.',
            REDIRECTMODAL_DESCRIPTION: 'You need to configure your settings before purchasing a shipping label.',
            REDIRECTMODAL_OKBUTTON: 'Go to setup',
            REDIRECTMODAL_TITLE_NOADDRESS: 'No Return Address',
            REDIRECTMODAL_TITLE_NOCARD: 'No Payment Method',
            REDIRECTMODAL_TITLE_NODEFAULTS: 'Settings not configured',
            RETURNADDRESS_CONFIGURESTOREADDRESS: 'configure store address...',
            RETURNADDRESS_INTRO: 'My return address is',
            RETURNADDRESS_MYSTOREADDRESS: 'my store address',
            WILL: 'will',
            WILLNOT: 'will not'
        },
        POSTAGEFULFILLMENT: {
            AMOUNTPAID: 'Amount paid for shipping:',
            ERRORGETTINGLABEL: 'Failed to get shipping label',
            ITEMS: '{{NUMBEROFITEMS}} items',
            LINEWEIGHT: 'Line Weight',
            NOTNOW: 'Notnow',
            OPTIONS: 'Options',
            PACKAGEDETAILS: 'Package Details',
            PACKAGEDETAILSDESC: 'Based on the weight of your products, we\'ve prefilled an approximate total shipping weight. Confirm this weight and select a package to continue to label purchasing.',
            PREFERREDLABELFORMAT: 'Preferred label format',
            PRINTLABEL: 'Print label',
            PRINTPACKINGSLIP: 'Print Packing Slip',
            PRINTRETURNLABEL: 'Print Return label',
            PRODUCT: 'Product',
            PRODUCTINFORMATION: 'Product Information',
            PRODUCTINFORMATIONDESC: 'Review the ordered products and confirm product options and weight.',
            PRODUCTTOTALS: 'Product Totals',
            PURCHASERETURNPOSTAGE: 'Purchase return postage',
            QTY: 'Qty.',
            REFUNDMODAL_DESCRIPTION: 'You will get a refund of {{refundamount}}, and the label will be invalidated.',
            REFUNDMODAL_OKBUTTON: 'Get refund',
            REFUNDMODAL_TITLE: 'Refund shipping label?',
            SHIPPINGLABELPURCHASED: 'Shipping label purchased',
            SKU: 'SKU:',
            TITLE1: 'Fulfill Order Shipment',
            TITLE2: 'Purchase Shipping Label',
            TITLE3: 'Label Purchase Confirmation',
            TRACKINGNUMBER: 'Tracking number:',
            WEIGHT: 'Weight',
            WEIGHTLBS: '{{WEIGHT}} lbs.'
        },
        PRIVY: {
            CONNECT_PRIVY: 'Connect Privy Account',
            DESCRIPTION: 'Customizable, mobile-friendly display types including popups, spin to win, banners, flyouts, scroll boxes, announcement bars, and embedded forms for email collection.',
            HEADING: 'Get email subscribers using banners, triggered pop-ups, and coupons',
            HELP: 'Don\'t have a Privy account?',
            INPUT_LABEL: 'Paste your Privy account identifier to connect.',
            INPUT_PLACEHOLDER: 'i.e. A1B8C78G0915EA2456AE3176',
            LINK: 'Sign up for free.',
            MANAGE: 'Manage',
            MANAGE_MESSAGE: 'Your store is now ready to collect email addresses and display custom banners.',
            MODAL_LINK: 'Learn How',
            MODAL_TITLE: 'Screenshot of Privy dashboard',
            TITLE: 'Privy'
        },
        PRODUCT: {
            ACTIVEPRODUCTS: 'Displayed Products',
            ADD: 'Add a Product',
            ALLPRODUCTS: 'All Products',
            ATTACH_PAGE: 'Attach a page',
            CHOOSE_PAGE: 'Choose a page',
            CREATE_BUTTON_LABEL: 'Create Product',
            DELETE: 'Remove this product?',
            DESCRIPTION: 'Description',
            DESCRIPTION_CREATOR_ATTRIBUTES_NO_PRODUCT_NAME: 'Choose attributes',
            DESCRIPTION_CREATOR_ATTRIBUTES_PRODUCT_NAME: 'P',
            DESCRIPTION_CREATOR_BUTTON: 'Help me write',
            DESCRIPTION_CREATOR_CARD_TITLE: 'Quick Write',
            DESCRIPTION_CREATOR_CATEGORY: '{{PRODUCT_NAME}} category:',
            DESCRIPTION_CREATOR_DESCRIPTIVE_QUESTION: '{{PRODUCT_NAME}} is',
            DESCRIPTION_CREATOR_GENERATE_BUTTON: 'Generate Description',
            DESCRIPTION_CREATOR_IN_PROGRESS: 'Your base description has been updated below.',
            DESCRIPTION_CREATOR_INSTRUCTIONS: 'Get a jump start on your description! You can edit your full description later for grammar and personality.',
            DESCRIPTION_CREATOR_LOCATION_QUESTION: 'when they are',
            DESCRIPTION_CREATOR_MATERIAL: '{{PRODUCT_NAME}} material:',
            DESCRIPTION_CREATOR_NO_PRODUCT_NAME: 'This product is',
            DESCRIPTION_CREATOR_PERFECT_FOR_QUESTION: 'It\'s perfect for',
            DESCRIPTION_CREATOR_SEARCHPLACEHOLDER: 'Search Attributes',
            DESCRIPTION_CREATOR_SUBCATEGORY: '{{PRODUCT_NAME}} subcategory',
            DETACH_PAGE: 'Detach Page',
            DOESNOTEXIST: 'This product no longer exists.',
            EDIT: 'Update Product',
            EMPTYSEARCH: 'Begin typing to add a category',
            EXPORT_PRODUCTS_LINE1: 'You\'ve chosen to export {{PRODUCT_COUNT}} products.',
            EXPORT_PRODUCTS_LINE2: 'Note that the format will be CSV with different headers than your import files, so you can report on things like inventory levels and access image links quickly.',
            EXPORT_PRODUCTS_SUCCESS_MESSAGE: 'You will receive an email with a link to download the CSV with {{PRODUCT_COUNT}} products when it\'s ready. At peak times this could take several minutes.',
            EXPORT_PRODUCTS_START_EXPORT: 'Start Export',
            EXPORTPRODUCTSMENU: 'Export Products',
            HIDE: 'Hide Product',
            IMPORT_CUSTOMER_REVIEW_ADD: 'ADD EXISTING PRODUCT REVIEW',
            IMPORT_CUSTOMER_REVIEW_AUTHOR: 'Reviewer\'s Name',
            IMPORT_CUSTOMER_REVIEW_DATE: 'Date of Review',
            IMPORT_CUSTOMER_REVIEW_DESCRIPTION: 'Bring reviews you\'ve already earned to your Volusion store.  Add reviews you\'ve received from Facebook, Etsy, Yelp, Amazon or anywhere else on the web using this simple form.',
            IMPORT_CUSTOMER_REVIEW_FOR: 'REVIEW FOR',
            IMPORT_CUSTOMER_REVIEW_INPUT: 'Review',
            IMPORT_CUSTOMER_REVIEW_RATING: 'Rating received',
            IMPORT_CUSTOMER_REVIEW_SUBMIT: 'SUBMIT REVIEW',
            IMPORT_CUSTOMER_REVIEW_TIP: '*Reviews will appear in your product description text editor.',
            IMPORT_CUSTOMER_REVIEW_TITLE: 'PRODUCT REVIEWS',
            IMPORTPRODUCTSMENU: 'Import Products',
            INACTIVE: 'Hidden',
            INACTIVEPRODUCTS: 'Hidden Products',
            INSTOCK: 'in stock',
            INVALID_PAGE: 'We can\'t find your attached content page. This can happen if you deleted the page which was attached. To hide this message, attach a new page or click the \'Detach Page\' button, below.',
            INVENTORY: 'Inventory',
            LIMITBADGE: '{{LIMIT}} Product Limit',
            LIMITREACHED: 'You\'ve reached your limit!',
            LIMITREACHEDBADGE: 'Product Limit Reached',
            LIMITREACHEDDESC1: 'Volusion Free has a max product limit of {{PRODUCTLIMIT}} products.',
            LIMITREACHEDDESC2: 'Upgrade to Volusion Plus to unlock unlimited products.',
            LIMITREACHEDDESCLINE1: 'Volusion Free has a max product limit of {{PRODUCTLIMIT}} products.',
            LIMITREACHEDDESCLINE2: 'Upgrade to Volusion Plus to unlock unlimited products.',
            NAME: 'product',
            NAMELABEL: 'Name',
            NEWINLAST30DAYS: 'New In Last 30 Days',
            NO_CONTENT_PAGES: 'You don\'t have any pages. Go to the <a href="/pages/add" title="Add a page">pages app</a> to create a new page.',
            NOPRODUCTS: 'No products found.',
            OR: 'Or',
            PLURAL: 'products',
            PRICE: 'Price',
            PRICEVARIANTS: 'Price modified by variants',
            PRODUCT_TITLE: 'Product Title',
            PRODUCTVARIANTS: 'product variants',
            QUANTITY: 'Qty',
            RELATEDPRODUCTS: 'Related Products',
            REQUIREMENT1: 'Maximum file size:',
            REQUIREMENT1VALUE: '5MB',
            REQUIREMENT2: 'File type:',
            REQUIREMENT2VALUE: 'Comma-separated values (.csv)',
            SALE_PRICE: 'Sale Price',
            SELECTEDPLURAL: '{{ITEMS}} Items selected',
            SELECTEDSINGLE: '{{ITEMS}} Item selected',
            SHIPPINGANDTAX: 'Shipping and Tax',
            SHIPPINGREQUIRED: 'Requires Shipping',
            SHOW: 'Show Product',
            SINGLE: 'product',
            SOURCE_SKU: 'Fulfiller Sku',
            STOPTRACKINGPRODUCTINVENTORYCONFIRMBODY: 'Stop tracking inventory for the product \'{{PRODUCT_NAME}}\'?',
            STOPTRACKINGPRODUCTINVENTORYCONFIRMHEADING: 'Are You Sure?',
            STOPTRACKINGPRODUCTINVENTORYCONFIRMNO: 'Cancel',
            STOPTRACKINGPRODUCTINVENTORYCONFIRMYES: 'Stop Tracking Inventory',
            SUCCESSEXTENSIONS: 'Installed {{COUNT}} extensions',
            TAXABLE: 'Taxable',
            TOTALPRODUCTS: 'Total Products',
            VARIANTIMAGESMODALGROUPIMAGE: 'GROUP IMAGE',
            VARIANTIMAGESMODALHEADINGSUBTEXT: 'Select and/or upload images for this variant',
            VARIANTIMAGESMODALNAMELABEL: 'Variant name:',
            VARIANTIMAGESMODALPRODUCTVARIANT: 'Product Variant:',
            VARIANTIMAGESMODALSELECTEDCOUNT: 'Selected',
            VARIANTIMAGESMODALSKU: 'SKU:',
            VARIANTIMAGESMODALTITLE: 'Variant Images',
            VARIANTIMAGESMODALTITLESELECT: 'Select',
            VARIANTIMAGESMODALUSEBUTTON: 'USE',
            VARIANTIMAGESMODALVALUELABEL: 'Variant value:',
            VARIANTIMAGESSKUMODALHEADINGSUBTEXT: 'Select and/or upload images for this variant. Override group level images.'
        },
        REGISTER: {
            CREDITCARD_CVV_LABEL: 'CVC',
            CREDITCARD_CVV_REQUIRED: 'CVC is required.',
            CREDITCARD_CVV_VALID: 'CVC must be valid.',
            CREDITCARD_EXP_LABEL: 'MM/YY',
            CREDITCARD_EXP_REQUIRED: 'Exp. is required.',
            CREDITCARD_EXP_VALID: 'Exp. must be valid.',
            CREDITCARD_NUMBER_LABEL: 'Card Number',
            CREDITCARD_NUMBER_REQUIRED: 'Card Number is required.',
            CREDITCARD_NUMBER_VALID: 'Card Number must be valid.',
            PROCESSINGSTEP1: 'Building your store',
            REGISTRATION_ERROR_DESCRIPTION: 'We could not register your store.',
            REGISTRATION_ERROR_TITLE: 'Registration Error'
        },
        SAVEBAR: {
            LOADING: 'Saving'
        },
        SCOPEPICKER: {
            DOLLARSIGN: '$',
            NORESULTS: 'You have not created any products or categories',
            NORESULTSCATEGORIES: 'You have not created any categories',
            NORESULTSFOR: 'No results for',
            NORESULTSPRODUCTS: 'You have not added any products',
            OFF: 'off -',
            PERCENT: '%',
            PRODUCTS: 'products',
            SEARCHPLACEHOLDER: 'Search categories/products...',
            SELECTED: 'selected',
            SELECTENONE: 'Select none',
            SELECTSCOPE: 'Select Categories/Products'
        },
        SEARCH: {
            CUSTOMERRESULTS: '{{COUNT}} customer results for {{QUERY}}',
            ORDERRESULTS: '{{COUNT}} order results for {{QUERY}}',
            PRODUCTRESULTS: '{{COUNT}} product results for {{QUERY}}',
            RESULTS: 'Search Results',
            SEARCH: 'Search...'
        },
        SEO: {
            FRIENDLYNAME: 'Page URL text',
            HINT: 'Read our <a href="https://www.volusion.com/blog/best-practices-for-creating-seo-friendly-title-tags-ecommerce/" target="_blank">blog post</a> about best practices for creating SEO-friendly title tags',
            METADESCRIPTIONSHORT: 'Meta Description',
            SEO: 'SEO',
            SUBHEAD: 'SEO = Search Engine Optimization. Improve search visibility and control your page\'s appearance in search results.',
            TITLE: 'Title Tag'
        },
        SHIPPING: {
            MARKSHIPPED: 'Mark as Shipped',
            MARKSHIPPEDDESCRIPTION: 'Ship and complete your order.',
            METHODNOTSPECIFIED: 'Not Specified',
            PACKINGSLIP: 'packing slip',
            PRINTLABEL: 'Print Shipping Label',
            PRINTSLIP: 'Print Packing Slip',
            PRINTINVOICE: 'Print Invoice',
            SHIPPINGMETHOD: 'Carrier',
            SHIPTO: 'Ship To',
            THANKYOU: 'thank you!',
            TRACKINGNUMBER: 'Tracking Number'
        },
        STORE: {
            CACHEREFRESHED: 'Cache successfully refreshed!',
            CACHEREFRESHERROR: 'Refreshing cache had an error',
            EMAILREQUIRED: 'Email is required',
            LOGOFAVICON: 'Logo and Favicon',
            LOGOUT: 'Log Out',
            RELEASENOTES: 'What\'s new?',
            STOREEMAIL: 'Store Email',
            STORENAME: 'Store Name',
            UPLOADFAVICONBLURB: 'Your favicon will display in the tab bar of your browser.',
            UPLOADFAVICONINSTRUCTION1: 'Dimensions: 32x32',
            UPLOADFAVICONINSTRUCTION2: 'File type: PNG',
            UPLOADLOGOBLURB: 'Upload your logo to be displayed on your storefront aswell as invoices, packing slips, and shipping labels.',
            UPLOADLOGOINSTRUCTION1: 'Maximum file size: 5MB',
            UPLOADLOGOINSTRUCTION2: 'File types: PNG, JPG, JPEG, GIF',
            VALIDEMAIL: 'A valid email is required'
        },
        STOREADDRESSES: {
            ADD: 'Add',
            CANCEL: 'Cancel',
            STORE_ADDRESSES: 'Store Addresses'
        },
        STORESETTINGS: {
            ADDTHISCONFIRMMODALTITLE: 'Are You Sure?',
            ADDTHISDESCRIPTION: 'Make it easy for shoppers to share your product links via email, on Facebook, Twitter, Pinterest, and Google Plus.',
            ADDTHISDISABLECONFIRMCANCEL: 'Cancel',
            ADDTHISDISABLECONFIRMDESCRIPTION: 'Disabling will remove the ability for your customers to share via the Social Sharing Widget. You can re-enable the Social Sharing Widget at any time.',
            ADDTHISDISABLECONFIRMOK: 'Disable',
            ADDTHISDISABLED: 'Disabled',
            ADDTHISENABLED: 'Enabled',
            ADDTHISTITLE: 'SHARE BUTTON',
            BADGE_EMAIL_VERIFIED: 'Email Verified',
            BADGE_LAUNCHED: 'Live',
            BADGE_NOT_LAUNCHED: 'Not Live',
            BADGE_NOTEMAIL: 'Email not verified',
            INTROFREEOTHERWISE: ', otherwise I\'ll charge',
            INTROPAYMENT: 'I will use',
            INTROPAYMENTSUFFIX: 'to collect payment',
            INTROSHIPPING: 'I will',
            INTROSHIPPINGCHARGE: ', and I\'ll charge',
            INTROSHIPPINGFOOTNOTE: '* You can create more advanced shipping methods later.',
            INTROSHIPPINGFREE: 'for all orders over',
            INTROSHIPPINGSUFFIX: 'per order',
            INTROSTATE: 'I am located in the state of',
            INTROSTORENAME: 'The name of my store is',
            INTROSTORENAMEPLACEHOLDER: '(optional)',
            INTROSUBMIT: 'Configure Settings',
            LAUNCH_YOUR_STORE: 'Launch your store',
            NAME: 'Settings',
            PAYMENTSTABTITLE: 'Payments',
            RESEND_EMAIL: 'Resend Verification Email',
            SEOHOMEPAGESEOCARDDESC: 'Add a title tag and meta description to your home page for use on the search engine results pages (SERPs).',
            SEOHOMEPAGESEOCARDTITLE: 'Homepage SEO',
            SEOHOMEPAGESEODESCTAGLABEL: 'Homepage meta description',
            SEOHOMEPAGESEODESCTAGPLACEHOLDER: 'Write compelling, readable ad copy to draw visitors using important keywords.',
            SEOHOMEPAGESEOGOOGLEPREVIEWMETADESCTAGEXAMPLE: 'This is your page description. The font and size of the description has not changed in the latest redesign. Descriptions get cut off after roughly 320 characters ...',
            SEOHOMEPAGESEOGOOGLEPREVIEWTITLE: 'Google result preview',
            SEOHOMEPAGESEOGOOGLEPREVIEWTITLETAGEXAMPLE: 'Primary Keyword - Secondary Keyword | Brand Name',
            SEOHOMEPAGESEOGOOGLEPREVIEWURLEXAMPLE: 'www.example.com/example',
            SEOHOMEPAGESEOTITLETAGLABEL: 'Homepage title tag',
            SEOHOMEPAGESEOTITLETAGPLACEHOLDER: 'e.g. Primary Keyword - Secondary Keyword | Brand Name',
            SEOSITEVERIFICATIONBINGLABEL: 'Bing Webmaster Tools',
            SEOSITEVERIFICATIONBINGPLACEHOLDER: 'e.g. 0FC3FD705126161B052E755A56F8952D',
            SEOSITEVERIFICATIONCARDDESC: 'Add verification meta tags for popular websites.',
            SEOSITEVERIFICATIONCARDTITLE: 'Verification Tags',
            SEOSITEVERIFICATIONGOOGLELABEL: 'Google Search Console',
            SEOSITEVERIFICATIONGOOGLEPLACEHOLDER: 'e.g. uEtG4638yYT42PzvFua6iiR1v+iJ2lfnUpZ/cJPdzKM=',
            SEOSITEVERIFICATIONPINTERESTLABEL: 'Pinterest',
            SEOSITEVERIFICATIONPINTERESTPLACEHOLDER: 'e.g. a20678558024142eb16eb12c1c69ba96',
            SEOTABTITLE: 'SEO',
            SHIPPINGACTIVE: 'Active',
            SHIPPINGADDFREE: 'Add Free Shipping',
            SHIPPINGADDMETHOD: 'Add Method',
            SHIPPINGBYPRICEDESC: 'Create and manage shipping rates based on the order subtotal.',
            SHIPPINGBYWEIGHTDESC: 'Create and manage shipping rates based on the order weight.',
            SHIPPINGCANCEL: 'Cancel',
            SHIPPINGCREATENEWRATE: 'Create New Rate',
            SHIPPINGCURRENCY: '$',
            SHIPPINGEDITPRICERATE: 'Edit Price Rate',
            SHIPPINGEDITWEIGHTRATE: 'Edit Weight Rate',
            SHIPPINGFREE: 'Free Shipping',
            SHIPPINGFREEALL: 'Free shipping on all orders',
            SHIPPINGFREEDESC: 'Reward your customers with free shipping.',
            SHIPPINGFREEOVER: 'Free shipping on orders over',
            SHIPPINGGOTOPRODUCTS: 'Go to products',
            SHIPPINGINPUTPRICERANGE: 'Input a price range. Add multiple delivery methods if necessary. Leave the Maximum order price empty if you don\'t want an upper limit on this rate.',
            SHIPPINGINPUTWEIGHTRANGE: 'Input a weight range. Add multiple delivery methods if necessary. Leave the Maximum order weight empty if you don\'t want an upper limit on this rate.',
            SHIPPINGMAXIMUMORDERPRICE: 'Maximum order price',
            SHIPPINGMAXIMUMORDERWEIGHT: 'Maximum order weight (in lbs)',
            SHIPPINGMETHODS: 'Shipping Methods',
            SHIPPINGMINIMUMORDERPRICE: 'Minimum order price',
            SHIPPINGMINIMUMORDERWEIGHT: 'Minimum order weight (in lbs)',
            SHIPPINGMISSINGPRODUCTWEIGHTS: 'Missing Product Weights',
            SHIPPINGMISSINGPRODUCTWEIGHTSMESSAGE: 'You have products and/or variants without weights. In order to use weight-based shipping rates, all products and variants require weight values. Please add weights to you products. All products and/or variants without weights will be treated as weighing 0lbs at checkout.',
            SHIPPINGNEWBYPRICE: 'New Price Rate',
            SHIPPINGNEWBYWEIGHT: 'New Weight Rate',
            SHIPPINGNEWPRICERATE: 'New Price Rate',
            SHIPPINGNEWWEIGHTRATE: 'New Weight Rate',
            SHIPPINGNOMAX: 'No maximum',
            SHIPPINGPREVIOUSPRICERATE: 'We\'ve added the methods from a previous price rate.',
            SHIPPINGPREVIOUSRATEDISMISS: 'Dismiss',
            SHIPPINGPREVIOUSRATEUNDO: 'Undo',
            SHIPPINGPREVIOUSWEIGHTRATE: 'We\'ve added the methods from a previous weight rate.',
            SHIPPINGPRICE: 'Shipping Price',
            SHIPPINGPRICEBASED: 'Price Based Rates',
            SHIPPINGPRICEOVERLAP: 'This rate overlaps another rate. Please change the price values.',
            SHIPPINGPRICERANGE: 'Order Price Range',
            SHIPPINGSAVERATE: 'Done Editing',
            SHIPPINGSUCCESSCREATED: 'successfully created.',
            SHIPPINGSUCCESSEDITED: 'successfully edited.',
            SHIPPINGSUCCESSPRICERATE: 'Price rate for',
            SHIPPINGSUCCESSWEIGHTRATE: 'Weight rate for',
            SHIPPINGTABTITLE: 'Shipping',
            SHIPPINGWEIGHTBASED: 'Weight Based Rates',
            SHIPPINGWEIGHTOVERLAP: 'This rate overlaps another rate. Please change the weight values.',
            SHIPPINGWEIGHTRANGE: 'Order Weight Range',
            SHIPPINGWEIGHTUNITS: 'lbs',
            SITEMAP_DESCRIPTION: 'You can find your sitemap.xml file here. We automatically refresh it once a day or you can manually refresh it below.',
            SITEMAP_DOWNLOAD: 'Download sitemap.xml',
            SITEMAP_LINKLABEL: 'Link to sitemap.xml',
            SITEMAP_REFRESH: 'Refresh sitemap.xml',
            SITEMAP_REFRESHED: 'Refreshed',
            SITEMAP_REFRESHERROR: 'Error Refreshing',
            SITEMAP_REFRESHING: 'Refreshing',
            SITEMAP_TITLE: 'Sitemap.xml',
            SOCIALACCOUNTSTITLE: 'Social Media Accounts',
            STATUS_NOTEMAIL_LAUNCHED: 'Your store is live but your email is unverified. Please click the link we sent you to verify your email address.',
            STATUS_NOTEMAIL_NOTLAUNCHED: 'Verification email has been sent to {{email}}. In order to launch your store, you must click the link we sent you to verify your email address.',
            STATUS_VERIFIED_LAUNCHED: 'Your store is live! Search engines can now index your site and show your site on search results.',
            STATUS_VERIFIED_NOTLAUNCHED: 'Your email has been successfully verified. You can now launch your store! This will allow search engines (like Google) to index your site and display it on search results.',
            STOREINFORMATIONTABTITLE: 'Store Info',
            TITLE_STORE_STATUS: 'Store Status'
        },
        STYLEEDITOR: {
            ADVANCED: 'Advanced CSS Editor',
            COLORS: 'Colors',
            COMPILEERROR: 'An error occurred.',
            CUSTOM: 'Custom',
            CUSTOMSTYLES: 'Custom Styles',
            FONTS: 'Fonts',
            PUBLISHCONFIRMBLOB: 'Publish changes to your live store?',
            PUBLISHCONFIRMTITLE: 'Publish',
            PUBLISHDIALOGCANCEL: 'No, do not publish',
            PUBLISHDIALOGOK: 'Yes, publish my changes',
            PUBLISHSUCCESS: 'Published successfully',
            RESTORE: 'Restore',
            REVERTCONFIRMBLOB: 'Restore the theme defaults? This erases any custom style changes.',
            REVERTCONFIRMRESTORE: 'Restore Theme Defaults',
            REVERTDIALOGLABEL: 'Publish Changes',
            REVERTDONOTRESTORE: 'Do not restore',
            REVERTRESTOREDEFAULTS: 'Restore defaults',
            REVERTSUCCESS: 'Theme Defaults Restored',
            UNDO: 'Undo',
            UNSAVEDCHANGES: 'You have unsavedchanges.',
            UNSAVEDCHANGESCANCEL: 'Cancel and Go Back',
            UNSAVEDCHANGESCONTINUE: 'Save and Continue',
            UNSAVEDCHANGESDIALOG: 'Save before continuing? You have unsaved changes that will be lost.'
        },
        SYSTEMSTATUS: {
            DEFAULTSTATUS: 'All Systems Operational',
            STATUSLABELV2: 'Volusion Status'
        },
        THEMESTORE: {
            ACTIVATE: 'Activate',
            ACTIVATESUCCESS: 'Your theme has been applied to your store.',
            ACTIVATING: 'Activating',
            ALLTHEMES: 'All Themes',
            CANCEL: 'cancel',
            CONFIRMACTIVATELINE1: 'Are you sure you want to make {{THEME}} your active theme?',
            CONFIRMACTIVATELINE2: '{{THEME}} will replace your current theme, {{CURRENTTHEME}}. This will take effect immediately, and the changes will be publicly visible on your storefront.',
            CONFIRMINSTALL: 'Confirm Install',
            CONFIRMPURCHASEALERT: 'This is a free theme. You will not be charged.',
            CONFIRMUPDATELINE1: 'Are you sure you want to update your theme to version {{VERSION}}?',
            CONFIRMUPDATELINE2: 'New in version {{VERSION}}:',
            CURRENCY: '$',
            CURRENTVERSION: 'Current version',
            DESCRIPTION: 'description',
            DEVELOPER: 'Developer',
            FEATURED: 'featured',
            FREE: 'free',
            INACTIVE: 'Inactive',
            INSTALL: 'install',
            INSTALLED: 'Installed',
            INSTALLING: 'Installing',
            INSTALLSUCCESS: 'Your theme is installed. Activate it to apply it to your store.',
            LIVE: 'Live',
            NOTHEMES: 'No themes found.',
            PREVIEW: 'preview',
            PURCHASE: 'purchase',
            SHORTVERSION: 'v',
            THEME: 'Theme',
            THEMEFEATURES: 'theme features',
            THEMEMARKETPLACE: 'Theme Store',
            THEMESTORE: 'Theme Store',
            THEMESUPPORTINFO: 'Theme Support',
            UPDATE: 'Update',
            UPDATEAVAILABLE: 'Update to',
            UPDATEERRORCONTENT: 'Well, it looks like there\'s a conflict with your site settings when updating your theme. You can continue to update to the latest version without all of your custom settings or return to your last version.',
            UPDATEERRORREVERT: 'Go Back to Previous Version',
            UPDATEERRORSAVE: 'Update Without Settings',
            UPDATEERRORTITLE: 'Well, that didn\'t work.',
            UPDATESUCCESS: 'There you go. Your theme’s all updated!',
            UPDATING: 'Updating',
            VERSION: 'version',
            WEBSITE: 'Website'
        },
        TITLETAG: {
            ABANDONED_CARTS: 'Abandoned Carts',
            ALLAPPS: 'All Apps',
            ALLTHEMES: 'All Themes',
            ANALYTICS: 'Analytics',
            APIKEYS: 'API Keys',
            APPSTORE: 'Integrations',
            CANCEL_STORE: 'Cancel Store',
            CATEGORIES: 'Categories',
            CATEGORY: 'Category',
            CUSTOMERS: 'Customers',
            DISCOUNTS: 'Discounts',
            EDITSTORE: 'Update Store',
            EDITSTORE_CONTENT: 'Update Content',
            EDITSTORE_LOGO: 'Update Logo',
            EDITSTORE_STYLES: 'Update Styles',
            EDITSTORE_THEMEDETAILS: 'Theme Details',
            EDITSTORE_THEMES: 'Themes',
            EDITSTORELANDING: 'Edit Store',
            FACEBOOKPIXEL: 'Facebook Pixel',
            FULFILLERS: 'Fulfillment Services',
            FULLSTORY: 'Fullstory',
            GOOGLEANALYTICS: 'Google Tracking',
            CHAT: 'Live Chat',
            INSTALLEDTHEMES: 'Installed Themes',
            INVOICE: 'Invoice',
            LANDING: 'Dashboard',
            MORE_COUNT: '{{COUNT}} more ...',
            MYACCOUNT: 'My Account',
            ORDERS: 'Orders',
            PACKINGSLIP: 'Packing Slip',
            PAGES: 'Pages',
            PRIVY: 'Privy',
            PRODUCTS: 'Products',
            SETTINGS: 'Settings',
            SHIPPINGLABEL: 'Shipping Label',
            THEMESTORE: 'Theme Store',
            YOTPO: 'Yotpo'
        },
        TOAST: {
            ACCEPTERROR: 'Problem processing your {{TYPE}}',
            MULTIREMOVE: '{{COUNT}} {{TYPE}} successfully removed',
            SUCCESSFULLYREMOVED: '{{NAME}} successfully removed'
        },
        TRIALSTATUSBAR: {
            TIMEREMAINING: 'Hey {{NAME}}, you have <b>{{TIMEREMAINING}} left</b> in your trial.',
            TIMEREMAININGSHORT: '<b>{{TIMEREMAINING}} left</b> in your trial.',
            TRIALEXPIRED: 'Your trial has expired.',
            TRIALEXPIREDSHORT: 'Trial expired.'
        },
        UPDATEPAYMENT: {
            DESCRIPTION: 'This is your default payment method for all Volusion admin purchases.',
            DESCRIPTION_NOTE: 'This is your default payment method for all Volusion admin purchases.',
            LAUNCH_MODAL_BUTTON: 'Change Payment Method',
            LAUNCH_MODAL_BUTTON_ADD: 'Add Payment Method',
            MODAL_CANCEL: 'Cancel',
            MODAL_ERROR: 'There was an issue updating your payment info.',
            MODAL_SAVE: 'Save Changes',
            MODAL_TITLE: 'Change Payment Method',
            MODAL_TITLE_NEW: 'New Payment Method'
        },
        UPDATEPAYMENTCARD: {
            ENDINGIN: 'ending in',
            EXP: 'Exp:'
        },
        VARIANTS: {
            ADDGROUP: 'Add Variant Group',
            ADDGROUPCONFIRMBODY: 'Adding a variant group will remove the inventory currently being tracked.',
            ADDGROUPCONFIRMHEADING: 'Are You Sure?',
            ADDGROUPCONFIRMNO: 'Cancel',
            ADDGROUPCONFIRMYES: 'Add Variant Group',
            DELETETHIS: 'Delete this variant',
            ENTERTOCREATE: 'PRESS ENTER TO CREATE',
            INLINENAMEPLACEHOLDER: '(e.g. Size, Color)',
            INLINEVALUEPLACEHOLDER: '(e.g. Small, Brown, Canvas)',
            INSTRUCTIONS: 'Does your product come in multiple variations? Add variant groups and values for each variation of your product, then assign prices to each product variant.',
            MENUHIDE: 'Hide this variant',
            MENUPRICERESET: 'Reset price override',
            MENUSHOW: 'Show this variant',
            NAMEHEADER: 'Variant Name',
            PLURAL: 'VARIANTS',
            PRICEDIFFERENCE: 'Price difference',
            PRODUCTSHEADERIMAGES: 'Images',
            PRODUCTSHEADERPRICE: 'Price',
            PRODUCTSHEADERQUANTITY: 'Quantity',
            PRODUCTSHEADERSKU: 'SKU',
            PRODUCTSHEADERVARIANT: 'Variant',
            PRODUCTSQUANTITYNOTSET: 'Not Set',
            PRODUCTSTABLEHEADER: 'Edit Products',
            REMOVEGROUPCONFIRMBODY: 'Deleting this variant group will remove all associated variant products and their price differences.',
            REMOVEGROUPCONFIRMHEADING: 'Are You Sure?',
            REMOVEGROUPCONFIRMNO: 'Cancel',
            REMOVEGROUPCONFIRMWITHINVENTORYBODY: 'Deleting this variant group will remove all associated variant products, their price differences and inventory.',
            REMOVEGROUPCONFIRMYES: 'Delete Variant Group',
            RESETINVENTORY: 'Reset Inventory',
            SHOW: 'Show variant',
            STOPTRACKING: 'Stop Tracking Inventory',
            STOPTRACKINGVARIANTINVENTORYCONFIRMBODY: 'Stop tracking inventory for the variant \'{{VARIANT_SKU}}\'?',
            STOPTRACKINGVARIANTINVENTORYCONFIRMHEADING: 'Are You Sure?',
            STOPTRACKINGVARIANTINVENTORYCONFIRMNO: 'Cancel',
            STOPTRACKINGVARIANTINVENTORYCONFIRMYES: 'Stop Tracking Inventory',
            TABLECOLLAPSE: 'Collapse Table',
            TABLEEXPAND: 'Expand Table',
            VALUEHEADER: 'Variant Values',
            VARIANTIMAGES: 'Variant Images'
        },
        YOTPO: {
            CONNECT_YOTPO: 'Connect to Yotpo',
            DESCRIPTION: 'Leverage customer reviews and photos throughout the buyer journey to increase trust, social proof, and sales.',
            DISCONNECT: 'Disconnect Account',
            HEADING: 'Turn your happy customers into your best marketers',
            MANAGE: 'Manage Account',
            MANAGE_MESSAGE: 'Your Yotpo account is connected',
            TITLE: 'Yotpo',
            CONFIRM_DISCONNECT_TITLE: 'Disconnect Yotpo',
            CONFIRM_DISCONNECT_MESSAGE: 'Are you sure you want to disconnect? This will prevent Yotpo content like product reviews from being displayed on your store.',
            CONFIRM_DISCONNECT_ARIA: 'Confirm Disconnect Yotpo',
            CONFIRM_DISCONNECT_CONFIRM_TOAST: 'Yotpo successfully disconnected',
            CONFIRM_DISCONNECT_CANCEL_TOAST: 'Disconnect canceled'
        },
        DASHBOARD: {
            ADD_APP_TITLE: 'Add App',
            ADVISOR_CTA_CHAT: 'Chat now',
            ADVISOR_HELLO_TEXT: 'I’m dedicated to helping your business achieve success and growth. From best practices to industry standards, I’ll help you take your store to the next level.',
            DISMISS_CARD_MENU: 'Dismiss',
            FOOTER_BLOG_TITLE: 'Volusion Blog',
            FOOTER_BLOG_SUBTITLE: 'Fresh ecommerce insights from our in-house experts',
            FOOTER_GUIDES_TITLE: 'Ecommerce Guides',
            FOOTER_GUIDES_SUBTITLE: 'Comprehensive guides and online business resources',
            FOOTER_HELP_TITLE: 'Help Center',
            FOOTER_HELP_SUBTITLE: 'Reference expertly-written support articles and tutorials',
            FOOTER_SERVICES_TITLE: 'Volusion Design & Marketing Services',
            FOOTER_SERVICES_SUBTITLE: 'Our in-house and marketing team will create the perfect site for you',
            NOTICE_TRIAL_TITLE: 'Free Trial',
            NOTICE_TRIAL_EXPIRED: 'Your trial has expired. Start selling now!',
            NOTICE_TRIAL_TIME_REMAINING: 'You have {{TIMEREMAINING}} days left in your trial',
            NOTICE_TRIAL_ACTION: 'Select a Plan',
            NOTICE_ORDERS_TITLE: 'Orders',
            NOTICE_ORDERS_MESSAGE: 'You have {{ORDERCOUNT}} orders totalling {{ORDERTOTAL}}',
            NOTICE_ORDERS_ACTION: 'View Orders',
            SECTION_NEXTSTEPS_TRIAL_TITLE: 'Get Started',
            SECTION_NEXTSTEPS_TRIAL_SUBTITLE: 'Here are some recommended steps to set up your online store.',
            SECTION_NEXTSTEPS_TITLE: 'Apps to help you grow',
            SECTION_NEXTSTEPS_SUBTITLE: 'Try one of these top recommended apps to help your business.'
        },
        DASHBOARD_ANALYTICS: {
            MENU_TODAY: 'Today',
            MENU_YESTERDAY: 'Yesterday',
            MENU_7_DAYS: 'Last 7 Days',
            MENU_30_DAYS: 'Last 30 Days',
            MENU_MONTH: 'Month to Date'
        },
        DASHBOARD_ANNOUNCEMENT: {
            SUBTITLE: 'Introducing',
            TITLE: 'Your Store’s New Homepage',
            ANNOUNCEMENT_TEXT: 'Your new home page includes new order notifications and at-a-glance analytics. We’ll also start recommending new apps to help your business grow.',
            ANNOUNCEMENT_CTA: 'Got it - Let Me In'
        },
        NEXTSTEPS: {
            CARD_ACTIONS_VIDEO: 'Watch Video',
            CARD_THEMES_NAME: 'Themes',
            CARD_THEMES_FULL_HEADLINE: 'Pick the Perfect Look <br> for Your Brand',
            CARD_THEMES_SMALL_HEADLINE: 'Pick the Perfect Look for Your Brand',
            CARD_THEMES_FULL_CTA: 'Browse Themes',
            CARD_THEMES_COMPLETED_CTA: 'View Themes',
            CARD_THEMES_FULL_SUMMARY: 'Your theme is how your store looks to the world. Customize it right here.',
            CARD_THEMES_SMALL_SUMMARY: 'Your theme is how your store looks to the world. Customize it right here.',
            CARD_THEMES_COMPLETED_SUMMARY: 'Change your mind? You can customize your theme anytime.',
            CARD_PRODUCTS_NAME: 'Products',
            CARD_PRODUCTS_FULL_HEADLINE: 'Add a Product and <br> Start Selling',
            CARD_PRODUCTS_SMALL_HEADLINE: 'Add a Product and Start Selling',
            CARD_PRODUCTS_FULL_CTA: 'Add Products',
            CARD_PRODUCTS_COMPLETED_CTA: 'View Products',
            CARD_PRODUCTS_FULL_SUMMARY: 'You have products, so let’s get them on your shelves.',
            CARD_PRODUCTS_SMALL_SUMMARY: 'You have products, so let’s get them on your shelves.',
            CARD_PRODUCTS_COMPLETED_SUMMARY: 'You can always add products when you have new merch to sell.',
            CARD_CATEGORIES_NAME: 'Categories',
            CARD_CATEGORIES_FULL_HEADLINE: 'Organize Your Items <br> into Categories',
            CARD_CATEGORIES_SMALL_HEADLINE: 'Organize Your Items into Categories',
            CARD_CATEGORIES_FULL_CTA: 'Add Categories',
            CARD_CATEGORIES_COMPLETED_CTA: 'View Categories',
            CARD_CATEGORIES_FULL_SUMMARY: 'Add your products to a category or subcategory to organize your store.',
            CARD_CATEGORIES_SMALL_SUMMARY: 'Add your products to a category or subcategory to organize your store.',
            CARD_CATEGORIES_COMPLETED_SUMMARY: 'Switching things up? You can add or edit your categories anytime.',
            CARD_CUSTOMERS_NAME: 'Customers',
            CARD_CUSTOMERS_FULL_HEADLINE: 'Keep in Touch With Your Customers',
            CARD_CUSTOMERS_SMALL_HEADLINE: 'Customers',
            CARD_CUSTOMERS_FULL_CTA: 'View Customers',
            CARD_CUSTOMERS_COMPLETED_CTA: 'Customers',
            CARD_CUSTOMERS_FULL_SUMMARY: 'Manage relationships with your current and existing customers right here.',
            CARD_CUSTOMERS_SMALL_SUMMARY: 'Manage relationships with your current and existing customers right here.',
            CARD_CUSTOMERS_COMPLETED_SUMMARY: 'Manage your customers whenever you need.',
            CARD_PAGES_NAME: 'Pages',
            CARD_PAGES_FULL_HEADLINE: 'Tell Your Story with <br> Custom Pages',
            CARD_PAGES_SMALL_HEADLINE: 'Add Custom Pages',
            CARD_PAGES_FULL_CTA: 'Add Pages',
            CARD_PAGES_COMPLETED_CTA: 'View Pages',
            CARD_PAGES_FULL_SUMMARY: 'Create pages for contact info, about us, terms & conditions — whatever you want to share.',
            CARD_PAGES_SMALL_SUMMARY: 'Create pages for contact info, about us, terms & conditions — whatever you want to share.',
            CARD_PAGES_COMPLETED_SUMMARY: 'Add all the pages your heart desires.',
            CARD_APPSTORE_NAME: 'Integrations',
            CARD_APPSTORE_FULL_HEADLINE: 'Expand Your Toolbox With <br> Our Integrations',
            CARD_APPSTORE_SMALL_HEADLINE: 'Check out our Integrations',
            CARD_APPSTORE_FULL_CTA: 'View Integrations',
            CARD_APPSTORE_COMPLETED_CTA: 'View Integrations',
            CARD_APPSTORE_FULL_SUMMARY: 'Boost your business with our integrated apps.',
            CARD_APPSTORE_SMALL_SUMMARY: 'Boost your business with our integrated apps.',
            CARD_APPSTORE_COMPLETED_SUMMARY: 'Check out the Integrations for even more great additions to your site.',
            CARD_DISCOUNTS_NAME: 'Discounts',
            CARD_DISCOUNTS_FULL_HEADLINE: 'Entice Customers <br> with Discounts',
            CARD_DISCOUNTS_SMALL_HEADLINE: 'Create Discounts',
            CARD_DISCOUNTS_FULL_CTA: 'View App',
            CARD_DISCOUNTS_COMPLETED_CTA: 'Discounts',
            CARD_DISCOUNTS_FULL_SUMMARY: 'Improve conversions with deals on products, categories or throughout your store.',
            CARD_DISCOUNTS_SMALL_SUMMARY: 'Offer customers an even more enticing shopping experience.',
            CARD_DISCOUNTS_COMPLETED_SUMMARY: 'Create discounts to get customers coming back for more.',
            CARD_SHIPPO_NAME: 'Shippo',
            CARD_SHIPPO_FULL_HEADLINE: 'Handle Postage <br> with Ease',
            CARD_SHIPPO_SMALL_HEADLINE: 'Shippo',
            CARD_SHIPPO_FULL_CTA: 'View App',
            CARD_SHIPPO_COMPLETED_CTA: 'View App',
            CARD_SHIPPO_FULL_SUMMARY: 'Compare prices across carriers and then purchase and print shipping labels.',
            CARD_SHIPPO_SMALL_SUMMARY: 'Compare prices across carriers and then purchase and print shipping labels.',
            CARD_SHIPPO_COMPLETED_SUMMARY: 'Configure your postage preference whenever you need.',
            CARD_PINTEREST_NAME: 'Pinterest',
            CARD_PINTEREST_FULL_HEADLINE: 'Start Selling <br> on Pinterest',
            CARD_PINTEREST_SMALL_HEADLINE: 'Pinterest',
            CARD_PINTEREST_FULL_CTA: 'View App',
            CARD_PINTEREST_COMPLETED_CTA: 'View App',
            CARD_PINTEREST_FULL_SUMMARY: 'Connect your Pinterest account (or set one up) and post product images directly to your boards.',
            CARD_PINTEREST_SMALL_SUMMARY: 'Connect your Pinterest account (or set one up) and post product images directly to your boards.',
            CARD_PINTEREST_COMPLETED_SUMMARY: 'Configure your Pinterest app any time you need.',
            CARD_FACEBOOKPIXEL_NAME: 'Facebook Pixel',
            CARD_FACEBOOKPIXEL_FULL_HEADLINE: 'Track Facebook Ad <br> Performance',
            CARD_FACEBOOKPIXEL_SMALL_HEADLINE: 'Facebook Pixel',
            CARD_FACEBOOKPIXEL_FULL_CTA: 'Install Pixel',
            CARD_FACEBOOKPIXEL_COMPLETED_CTA: 'View App',
            CARD_FACEBOOKPIXEL_FULL_SUMMARY: 'See how well your ads are doingwith Facebook Pixel.',
            CARD_FACEBOOKPIXEL_SMALL_SUMMARY: 'See how well your ads are doing with Facebook Pixel.',
            CARD_FACEBOOKPIXEL_COMPLETED_SUMMARY: 'Configure your Facebook Pixel whenever you’d like.',
            CARD_FULLSTORY_NAME: 'Fullstory',
            CARD_FULLSTORY_FULL_HEADLINE: 'View Your <br> Visitor Activity',
            CARD_FULLSTORY_SMALL_HEADLINE: 'Fullstory',
            CARD_FULLSTORY_FULL_CTA: 'View App',
            CARD_FULLSTORY_COMPLETED_CTA: 'View App',
            CARD_FULLSTORY_FULL_SUMMARY: 'View all in-browser interactions with Fullstory.',
            CARD_FULLSTORY_SMALL_SUMMARY: 'View all in-browser interactions with Fullstory.',
            CARD_FULLSTORY_COMPLETED_SUMMARY: 'Configure Fullstory anytime.',
            CARD_GOOGLEANALYTICS_NAME: 'Google Analytics',
            CARD_GOOGLEANALYTICS_FULL_HEADLINE: 'Track Store Data <br> with Google Analytics',
            CARD_GOOGLEANALYTICS_SMALL_HEADLINE: 'Google Analytics',
            CARD_GOOGLEANALYTICS_FULL_CTA: 'View App',
            CARD_GOOGLEANALYTICS_COMPLETED_CTA: 'View App',
            CARD_GOOGLEANALYTICS_FULL_SUMMARY: 'Send your site’s data to Google Analytics with our easy integration.',
            CARD_GOOGLEANALYTICS_SMALL_SUMMARY: 'Send your site’s data to Google Analytics with our easy integration.',
            CARD_GOOGLEANALYTICS_COMPLETED_SUMMARY: 'Configure your Google Analytics App Settings anytime.',
            CARD_PRIVY_NAME: 'Privy',
            CARD_PRIVY_FULL_HEADLINE: 'Manage Your Email <br> Lists With Privy',
            CARD_PRIVY_SMALL_HEADLINE: 'Privy',
            CARD_PRIVY_FULL_CTA: 'View App',
            CARD_PRIVY_COMPLETED_CTA: 'View App',
            CARD_PRIVY_FULL_SUMMARY: 'Build your email lists for promotions, newsletters blogs and more.',
            CARD_PRIVY_SMALL_SUMMARY: 'Build your email lists for promotions, newsletters blogs and more.',
            CARD_PRIVY_COMPLETED_SUMMARY: 'Manage your email lists whenever works for you.',
            CARD_SETTINGS_NAME: 'Settings',
            CARD_SETTINGS_FULL_HEADLINE: 'Set Up Payments <br> & Shipping',
            CARD_SETTINGS_SMALL_HEADLINE: 'Set up Payments & Shipping',
            CARD_SETTINGS_FULL_CTA: 'Go To Settings',
            CARD_SETTINGS_COMPLETED_CTA: 'View Settings',
            CARD_SETTINGS_FULL_SUMMARY: 'Configure your store information, along with payment and shipping methods.',
            CARD_SETTINGS_SMALL_SUMMARY: 'Configure your store information, along with payment and shipping methods.',
            CARD_SETTINGS_COMPLETED_SUMMARY: 'You can make changes to your store settings whenever you’d like.',
            CARD_STOREEDITOR_NAME: 'Store Editor',
            CARD_STOREEDITOR_FULL_HEADLINE: 'Customize the Look + Feel <br> of Your Site',
            CARD_STOREEDITOR_SMALL_HEADLINE: 'Edit Your Site',
            CARD_STOREEDITOR_FULL_CTA: 'Edit Site',
            CARD_STOREEDITOR_COMPLETED_CTA: 'Edit Store',
            CARD_STOREEDITOR_FULL_SUMMARY: 'Check out your storefront website to personalize your content and style.',
            CARD_STOREEDITOR_SMALL_SUMMARY: 'Check out your storefront website topersonalize your content and style.',
            CARD_STOREEDITOR_COMPLETED_SUMMARY: 'Continue customizing or move on to the next step.',
            CARD_LOGO_NAME: 'Logo',
            CARD_LOGO_FULL_HEADLINE: 'Stand Out with <br> a Store Logo',
            CARD_LOGO_SMALL_HEADLINE: 'Logo',
            CARD_LOGO_FULL_CTA: 'Upload Logo',
            CARD_LOGO_COMPLETED_CTA: 'Update Logo',
            CARD_LOGO_FULL_SUMMARY: 'Give your site a personal touch by adding your own logo.',
            CARD_LOGO_SMALL_SUMMARY: 'Give your site a personal touch by adding your own logo.',
            CARD_LOGO_COMPLETED_SUMMARY: 'Need a new look? You can change your logo at any time.',
            CARD_MENU_NAME: 'Menu',
            CARD_MENU_FULL_HEADLINE: 'Add Your <br> Site’s Navigation',
            CARD_MENU_SMALL_HEADLINE: 'Menu',
            CARD_MENU_FULL_CTA: 'Edit Menu',
            CARD_MENU_COMPLETED_CTA: 'Update Menu',
            CARD_MENU_FULL_SUMMARY: 'Direct your customers where you want them to go by adding a menu.',
            CARD_MENU_SMALL_SUMMARY: 'Direct your customers where you want them to go by adding a menu.',
            CARD_MENU_COMPLETED_SUMMARY: 'Switching it up? You can change your menu at any time.',
            CARD_ANALYTICS_NAME: 'Analytics',
            CARD_ANALYTICS_FULL_HEADLINE: 'Track Your Store’s Success',
            CARD_ANALYTICS_SMALL_HEADLINE: 'Analytics',
            CARD_ANALYTICS_FULL_CTA: 'View Analytics',
            CARD_ANALYTICS_COMPLETED_CTA: 'Analytics',
            CARD_ANALYTICS_FULL_SUMMARY: 'Use our Analytics app to see metrics like site visits and sales performance.',
            CARD_ANALYTICS_SMALL_SUMMARY: 'Use our Analytics app to see metrics like site visits and sales performance.',
            CARD_ANALYTICS_COMPLETED_SUMMARY: 'View your site’s performance at anytime.',
            CARD_MAILCHIMP_NAME: 'MailChimp',
            CARD_MAILCHIMP_FULL_HEADLINE: 'Automate <br> Your Emails',
            CARD_MAILCHIMP_SMALL_HEADLINE: 'MailChimp',
            CARD_MAILCHIMP_FULL_CTA: 'View App',
            CARD_MAILCHIMP_COMPLETED_CTA: 'View App',
            CARD_MAILCHIMP_FULL_SUMMARY: 'Set up, track and measure email effectiveness with your customers.',
            CARD_MAILCHIMP_SMALL_SUMMARY: 'Set up, track and measure email effectiveness with your customers.',
            CARD_MAILCHIMP_COMPLETED_SUMMARY: 'Configure your MailChimp settings anytime.',
            COMPLETE_LABEL_ADD_ANOTHER: 'Add Another',
            COMPLETE_PRODUCT_TITLE: 'Product Added',
            COMPLETE_PRODUCT_SUBTITLE: 'View your product on your storefront or add another',
            COMPLETE_PRODUCT_CTA_LABEL: 'View Product',
            COMPLETE_PRODUCT_INITIAL_STEP_MESSAGE: 'Add a Category',
            COMPLETE_CUSTOMERS_TITLE: 'Customer Added!',
            COMPLETE_CUSTOMERS_SUBTITLE: '',
            COMPLETE_CUSTOMERS_CTA_LABEL: 'Add Another',
            COMPLETE_CUSTOMERS_INITIAL_STEP_MESSAGE: 'Set Up an Email List with Mailchimp',
            COMPLETE_SETTINGS_TITLE: 'Initial Setup Complete',
            COMPLETE_SETTINGS_SUBTITLE: 'Make changes to your payments, shipping and other store info here',
            COMPLETE_CATEGORY_TITLE: 'Category Added',
            COMPLETE_CATEGORY_SUBTITLE: 'View your category on your storefront or add another',
            COMPLETE_CATEGORY_CTA_LABEL: 'View Category',
            COMPLETE_CATEGORY_INITIAL_STEP_MESSAGE: 'Organize your Menu',
            COMPLETE_THEME_TITLE: '{{THEMENAME}} Theme is now live!',
            COMPLETE_THEME_SUBTITLE: 'View your storefront or try customizing your theme’s appearance',
            COMPLETE_THEME_CTA_LABEL: 'Customize Theme',
            COMPLETE_PAGES_TITLE: 'Page Added!',
            COMPLETE_PAGES_SUBTITLE: 'View your page on your storefront or add another',
            COMPLETE_PAGES_INITIAL_STEP_MESSAGE: 'Organize your Menu',
            COMPLETE_PAGES_CTA_LABEL: 'View Page',
            OPEN_STOREFRONT: 'View Storefront',
            LABEL_NEXT_STEP: 'Next Step:'
        },
        CUSTOMER_ACCOUNT_INFO: {
            TITLE: 'Account info',
            ACCOUNT_ACTIVE: 'Active',
            ACCOUNT_INACTIVE: 'Not created',
            ACCOUNT_INACTIVE_LONG: 'Customer has not created an account',
            CREATED_ON: 'Created on'
        },
        CUSTOMER_ADDRESS_FORM: {
            FIRST_NAME_PLACEHOLDER: 'First name',
            FIRST_NAME_ERROR_REQUIRED: 'First name is required.',
            LAST_NAME_PLACEHOLDER: 'Last name',
            LAST_NAME_ERROR_REQUIRED: 'Last name is required.',
            ADDRESS_1_PLACEHOLDER: 'Address 1',
            ADDRESS_1_ERROR_REQUIRED: 'Address 1 is required.',
            ADDRESS_2_PLACEHOLDER: 'Address 2',
            CITY_PLACEHOLDER: 'City',
            CITY_ERROR_REQUIRED: 'City is required.',
            CITY_ERROR_NO_SPECIAL: 'City must not contain special characters.',
            STATE_PLACEHOLDER: 'State',
            ZIP_PLACEHOLDER: 'Zip',
            ZIP_ERROR_REQUIRED: 'ZIP Code is required.',
            ZIP_ERROR_FORMAT: 'ZIP Code must be in the proper format.'
        },
        CUSTOMER_CONTACT_INFO_FORM: {
            TITLE: 'Contact info',
            ACCEPTS_MARKETING: 'Accepts marketing',
            EMAIL_BUTTON: 'Email',
            CALL_BUTTON: 'Call',
            FIRST_NAME_PLACEHOLDER: 'First name',
            LAST_NAME_PLACEHOLDER: 'Last name',
            EMAIL_PLACEHOLDER: 'Email',
            EMAIL_ERROR_VALID: 'A valid email is required',
            EMAIL_ERROR_REQUIRED: 'Email is required.',
            PHONE_PLACEHOLDER: 'Phone number',
            PHONE_ERROR_VALID: 'Please enter a valid phone number.',
            ACCEPTS_MARKETING_CHECKBOX: 'Customer accepts marketing'
        },
        CUSTOMER_NOTES_FORM: {
            TITLE: 'Notes',
            PLACEHOLDER: 'Add private customer notes here',
            INTERNAL: 'Internal use only'
        },
        AVALARA_ENTITY_USE_CODE_FORM: {
            TITLE: 'Entity Use Code',
            INTERNAL: 'For exemptions in AvaTax and other Avalara applications'
        },
        CUSTOMER_SUMMARY: {
            CUSTOMER_SINCE: 'Customer since',
            NO_ORDERS: 'has not yet placed an order.',
            HAS_PLACED: 'has placed',
            TOTAL: 'for a total of'
        },
        CUSTOMER_ORDER_HISTORY: {
            AVERAGE: 'average',
            NO_ORDERS: 'No orders to display',
            NO_ORDERS_LONG: 'Customer has not yet placed an order',
            ORDER_NUMBER: 'Order #',
            ORDER_PLACED: 'Order Placed',
            ORDER_STATUS: 'Order Status',
            ORDER_TOTAL: 'Order Total',
            TITLE: 'Order History'
        },
        CUSTOMER_SHIPPING_ADDRESS: {
            TITLE: 'Shipping addresses',
            NO_ADDRESSES: 'No shipping addresses to display',
            ADD_ADDRESS: 'Add new shipping address',
            DEFAULT: 'Default',
            EDIT: 'Edit',
            SET_DEFAULT_CHECKBOX: 'Set as default shipping address',
            CANCEL: 'Cancel',
            DELETE: 'Delete',
            MODAL_ADD_TITLE: 'Add shipping address',
            MODAL_ADD_CONFIRM: 'Add address',
            MODAL_EDIT_TITLE: 'Edit shipping address',
            MODAL_EDIT_CONFIRM: 'Edit address'
        },
        VIDEOSLIDER: {
            CATEGORIES_TITLE: 'Add a Category',
            CATEGORIES_TEXT: '<p>Creating a category groups and displays products together which makes it easier for your customers to find what they are looking for.</p><ol><li>Go to the Categories app</li><li>Click add a category</li><li>Give your category a name</li><li>Provide a description</li><li>Save</li></ol><p>To add your categories to your site\'s menu, go to the store editor app and tap on Menu. From there click the add button and select the category you wish to add!</p><p>Volusion makes it easy to organize your products so your customers spend less wonderingwhere to go and more time shopping.</p>',
            LOGO_TITLE: 'Upload a Logo',
            LOGO_TEXT: '<p>Personalize your Site by adding your company\'s logo.</p><p>To upload a logo:</p><ol><li>Go to the Store Editor App</li><li>Tap on Logo</li><li>Drag an image or browse your gallery to upload an image</li><li>Save</li></ol><p>Keep it simple! If you don\'t have an image, don\'t worry, your Store\'s name will populate by default.</p><p>Pro tip, make sure your logo looks good on mobile resolution as well!</p>',
            PAGES_TITLE: 'Add a Page',
            PAGES_TEXT: '<p>Pages are great for sharing your blog, and general information about your store.</p><ol><li>Go to the Pages app</li><li>Click add a page</li><li>Add a title to your page</li><li>Add content</li><li>Save</li></ol><p>Optionally you can add videos, images, or links in your description. Don\'t forget to put some meta information so search engines can find your product.</p>',
            PRODUCTS_TITLE: 'Add a Product',
            PRODUCTS_TEXT: '<p>Adding products one by one is easy:</p><ol><li>Go to the Products app</li><li>Click add a product</li><li>Name your product</li><li>Give it a price</li><li>Add an image and description</li><li>Save</li></ol><p>Optionally you can add a sales price and weight to your product. Don\'t forget to add some meta information so search engines can find your product. If you have multiple variations of your product you can add variants too!</p>',
            SETTINGS_TITLE: 'Configure your Settings',
            SETTINGS_TEXT: '<p>Before you start selling, you have to setup and review your Store settings. There are some important information you must configure so let\'s get started!</p><ol><li>Go to the Settings app</li><li>Add your Store\'s location</li><li>Choose how you will take payment</li><li>Configure your shipping options</li><li>Choose a name for your store (optional)</li></ol><p>Don\'t worry if you are not completely sure on this info, you can edit this information at anytime. If you already have a custom domain, you can also add it here in Settings.</p>',
            THEMES_TITLE: 'Choose a Theme',
            THEMES_TEXT: '<p>Themes change the look of your store, you can customize the font, colors, images, and more!</p><p>To install a theme:</p><ol><li>Go to the Theme Store app</li><li>Choose a theme that you like</li><li>Tap Install and confirm</li></ol><p>To edit your theme tap the Pencil icon in the preview panel, or go to the Store Editor app and customize the look of your Site!</p>'
        }
    }).name;

/* eslint-enable max-len */



// WEBPACK FOOTER //
// ./src/app/labels.js